
// // // import React, {
// // //   useEffect,
// // //   useLayoutEffect,
// // //   useMemo,
// // //   useRef,
// // //   useState,
// // // } from "react";
// // // import {
// // //   IconArrow,
// // //   IconDoc,
// // //   IconSearch,
// // //   IconDownload,
// // //   IconChevronDown,
// // //   IconCalendar,
// // //   IconUser,
// // //   IconClose,
// // //   IconSliders,
// // //   IconLayers,
// // //   IconClock,
// // //   IconChart,
// // // } from "./icons";
// // // import {
// // //   CATEGORIES,
// // //   CATEGORY_MAP,
// // //   TYPE_STYLES,
// // //   DOCUMENTS,
// // //   optionsFor,
// // //   formatDownloads,
// // //   formatSize,
// // //   openDoc,
// // //   downloadDoc,
// // // } from "../data/Research";

// // // /* ----------------------------- tiny utilities ---------------------------- */
// // // function useInView(opts = {}) {
// // //   const ref = useRef(null);
// // //   const [inView, setInView] = useState(false);
// // //   useEffect(() => {
// // //     const el = ref.current;
// // //     if (!el) return;
// // //     const ob = new IntersectionObserver(
// // //       ([e]) => {
// // //         if (e.isIntersecting) {
// // //           setInView(true);
// // //           ob.disconnect();
// // //         }
// // //       },
// // //       { threshold: 0.12, ...opts }
// // //     );
// // //     ob.observe(el);
// // //     return () => ob.disconnect();
// // //   }, []);
// // //   return [ref, inView];
// // // }

// // // function Reveal({ children, delay = 0, className = "" }) {
// // //   const [ref, inView] = useInView();
// // //   return (
// // //     <div
// // //       ref={ref}
// // //       className={`transition-all duration-700 ease-out ${
// // //         inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
// // //       } ${className}`}
// // //       style={{ transitionDelay: `${delay}ms` }}
// // //     >
// // //       {children}
// // //     </div>
// // //   );
// // // }

// // // function CountUp({ value, format = (n) => String(n), duration = 1100 }) {
// // //   const [ref, inView] = useInView();
// // //   const [display, setDisplay] = useState(0);
// // //   const fromRef = useRef(0);
// // //   useEffect(() => {
// // //     if (!inView) return;
// // //     const from = fromRef.current;
// // //     const to = value;
// // //     const start = performance.now();
// // //     let raf;
// // //     const tick = (now) => {
// // //       const t = Math.min(1, (now - start) / duration);
// // //       const eased = 1 - Math.pow(1 - t, 3);
// // //       const cur = Math.round(from + (to - from) * eased);
// // //       setDisplay(cur);
// // //       if (t < 1) raf = requestAnimationFrame(tick);
// // //       else fromRef.current = to;
// // //     };
// // //     raf = requestAnimationFrame(tick);
// // //     return () => cancelAnimationFrame(raf);
// // //   }, [inView, value, duration]);
// // //   return <span ref={ref}>{format(display)}</span>;
// // // }

// // // /* ------------------------------- document card --------------------------- */
// // // function DocCard({ doc, index }) {
// // //   const typeCls = TYPE_STYLES[doc.type] || TYPE_STYLES.REPORT;
// // //   return (
// // //     <Reveal delay={Math.min(index, 8) * 70} className="h-full">
// // //       <article className="group relative flex flex-col h-full bg-white rounded-2xl p-6 ring-1 ring-orange-200/50 shadow-sm hover:shadow-2xl hover:shadow-red-900/10 transition-all duration-300 hover:-translate-y-1.5 overflow-hidden">
// // //         <span className="absolute top-0 left-0 h-[3px] w-10 rounded-r-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-500 group-hover:w-full" />
// // //         <span className="pointer-events-none absolute -top-12 -right-12 w-28 h-28 rounded-full bg-orange-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

// // //         <div className="flex items-start gap-4">
// // //           <div className="relative w-12 h-12 shrink-0 rounded-xl bg-gradient-to-br from-[#FAF7F2] to-white ring-1 ring-orange-200/30 grid place-items-center text-red-700 transition-all duration-300 group-hover:from-red-700 group-hover:to-orange-600 group-hover:text-white group-hover:scale-105 group-hover:-rotate-3">
// // //             <IconDoc className="w-[22px] h-[22px]" />
// // //             <span className="absolute -bottom-1.5 -right-1.5 text-[8px] font-extrabold tracking-wider bg-red-700 text-white rounded px-1 py-px ring-2 ring-white group-hover:bg-white group-hover:text-red-700 transition-colors">
// // //               PDF
// // //             </span>
// // //           </div>
// // //           <div className="min-w-0 flex-1">
// // //             <h3 className="font-display text-[15.5px] leading-snug text-gray-900 line-clamp-2 group-hover:text-red-700 transition-colors duration-200">
// // //               {doc.title}
// // //             </h3>
// // //             <div className="mt-2 flex items-center gap-2 flex-wrap">
// // //               <span
// // //                 className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ring-1 ${typeCls}`}
// // //               >
// // //                 {doc.type}
// // //               </span>
// // //               <span className="text-[10px] font-semibold text-gray-400 inline-flex items-center gap-1">
// // //                 <IconLayers className="w-3 h-3" /> {doc.pages} pp
// // //               </span>
// // //               <span className="text-[10px] font-semibold text-gray-400">
// // //                 · {formatSize(doc.sizeKB)}
// // //               </span>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         <p className="mt-4 text-[13px] leading-relaxed text-gray-600 line-clamp-3">
// // //           {doc.abstract}
// // //         </p>

// // //         <div className="mt-5 grid grid-cols-2 gap-3 border-t border-dashed border-orange-200/30 pt-4">
// // //           <div className="min-w-0">
// // //             <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
// // //               Publication Date
// // //             </div>
// // //             <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5">
// // //               <IconCalendar className="w-3.5 h-3.5 text-orange-700" />
// // //               {doc.date}
// // //             </div>
// // //           </div>
// // //           <div className="min-w-0">
// // //             <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
// // //               Author
// // //             </div>
// // //             <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5 min-w-0">
// // //               <IconUser className="w-3.5 h-3.5 text-orange-700 shrink-0" />
// // //               <span className="truncate">{doc.author}</span>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         <div className="mt-3 flex items-center gap-1.5 text-[11px] text-gray-400">
// // //           <IconDownload className="w-3.5 h-3.5" />
// // //           <span className="font-semibold text-gray-500">
// // //             {formatDownloads(doc.downloads)}
// // //           </span>
// // //           <span>downloads</span>
// // //           <span className="mx-1 text-gray-300">·</span>
// // //           <span>{doc.region}</span>
// // //         </div>

// // //         <div className="mt-auto pt-5 flex items-stretch gap-2">
// // //           <button
// // //             onClick={() => openDoc(doc)}
// // //             className="group/btn flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-red-700 to-red-800 text-white text-[13px] font-semibold py-2.5 shadow-sm hover:from-orange-600 hover:to-red-700 transition-all duration-300 hover:shadow-lg hover:shadow-red-700/30"
// // //           >
// // //             <IconDoc className="w-4 h-4" />
// // //             View Document
// // //           </button>
// // //           <button
// // //             onClick={() => downloadDoc(doc)}
// // //             aria-label={`Download ${doc.title} (PDF)`}
// // //             className="w-11 shrink-0 grid place-items-center rounded-lg bg-[#FAF7F2] text-red-700 ring-1 ring-orange-200/30 hover:bg-amber-500 hover:text-white hover:ring-amber-500 transition-all duration-300"
// // //           >
// // //             <IconDownload className="w-[18px] h-[18px] transition-transform duration-300 group-hover:translate-y-0.5" />
// // //           </button>
// // //         </div>
// // //       </article>
// // //     </Reveal>
// // //   );
// // // }

// // // /* ----------------------------- styled select ----------------------------- */
// // // function Select({ label, value, onChange, options, allLabel = "All" }) {
// // //   return (
// // //     <label className="relative block">
// // //       <span className="sr-only">{label}</span>
// // //       <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[11px] font-bold uppercase tracking-wider text-gray-400 pointer-events-none">
// // //         {label}
// // //       </span>
// // //       <select
// // //         value={value}
// // //         onChange={(e) => onChange(e.target.value)}
// // //         className="w-full appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 focus:bg-white outline-none text-[13px] font-semibold text-gray-700 pl-[68px] pr-9 py-2.5 cursor-pointer transition"
// // //       >
// // //         <option value="All">{allLabel}</option>
// // //         {options.map((o) => (
// // //           <option key={o} value={o}>
// // //             {o}
// // //           </option>
// // //         ))}
// // //       </select>
// // //       <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
// // //     </label>
// // //   );
// // // }

// // // /* ------------------------- hover-expanding search ------------------------- */
// // // function HoverSearch({ query, setQuery, activeCat, onSubmit }) {
// // //   return (
// // //     <form
// // //       onSubmit={(e) => {
// // //         e.preventDefault();
// // //         onSubmit?.();
// // //       }}
// // //       className="group/search relative flex items-center gap-2 rounded-full bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus-within:ring-2 focus-within:ring-orange-500/70 hover:bg-white focus-within:bg-white transition-all duration-300 ease-out h-10 w-10 hover:w-64 focus-within:w-64 pl-2.5 pr-1 overflow-hidden shrink-0"
// // //     >
// // //       <IconSearch className="w-4 h-4 text-orange-700 shrink-0" />
// // //       <input
// // //         value={query}
// // //         onChange={(e) => setQuery(e.target.value)}
// // //         placeholder={`Search ${activeCat === "all" ? "repository" : "stream"}…`}
// // //         className="bg-transparent outline-none text-gray-900 placeholder:text-gray-400 text-[13px] w-full min-w-0 opacity-0 group-hover/search:opacity-100 group-focus-within/search:opacity-100 transition-opacity duration-200 delay-100"
// // //       />
// // //       {query && (
// // //         <button
// // //           type="button"
// // //           onClick={() => setQuery("")}
// // //           aria-label="Clear search"
// // //           className="w-6 h-6 shrink-0 rounded-full grid place-items-center text-gray-400 hover:bg-gray-100 hover:text-red-700 opacity-0 group-hover/search:opacity-100 group-focus-within/search:opacity-100 transition-opacity duration-200"
// // //         >
// // //           <IconClose className="w-3.5 h-3.5" stroke={2.4} />
// // //         </button>
// // //       )}
// // //     </form>
// // //   );
// // // }

// // // /* ----------------------------- breadcrumb ----------------------------- */
// // // function Breadcrumb({ label }) {
// // //   return (
// // //     <nav
// // //       aria-label="Breadcrumb"
// // //       className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
// // //     >
// // //       <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
// // //         <li>
// // //           <a
// // //             href="/"
// // //             className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
// // //           >
// // //             <svg
// // //               viewBox="0 0 24 24"
// // //               className="h-4 w-4"
// // //               fill="none"
// // //               stroke="currentColor"
// // //               strokeWidth={2.2}
// // //               strokeLinecap="round"
// // //               strokeLinejoin="round"
// // //             >
// // //               <path d="M3 10.5 12 3l9 7.5" />
// // //               <path d="M5 10v10h14V10" />
// // //               <path d="M9 20v-6h6v6" />
// // //             </svg>
// // //             Home
// // //           </a>
// // //         </li>
// // //         <li className="text-black/30">&rsaquo;</li>
// // //         <li>
// // //           <span className="transition-colors duration-300 hover:text-[#DA2128]">
// // //             Global Research
// // //           </span>
// // //         </li>
// // //         <li className="text-black/30">&rsaquo;</li>
// // //         <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">
// // //           {label}
// // //         </li>
// // //       </ol>
// // //     </nav>
// // //   );
// // // }

// // // /* =========================================================================== *
// // //  *  REPOSITORY PAGE
// // //  * =========================================================================== */
// // // export default function ResearchRepository({ categoryKey, navigate, query, setQuery }) {
// // //   const meta = CATEGORY_MAP[categoryKey] || CATEGORY_MAP.all;
// // //   const CatIcon = meta.icon;

// // //   const [activeCat, setActiveCat] = useState(categoryKey);
// // //   const [year, setYear] = useState("All");
// // //   const [topic, setTopic] = useState("All");
// // //   const [region, setRegion] = useState("All");
// // //   const [typeF, setTypeF] = useState("All");
// // //   const [sort, setSort] = useState("latest");
// // //   const [visible, setVisible] = useState(6);
// // //   const [filtersOpen, setFiltersOpen] = useState(true);

// // //   const opts = useMemo(() => optionsFor(activeCat), [activeCat]);

// // //   // Keep activeCat in sync with the categoryKey prop — this component doesn't
// // //   // remount on route changes (React Router reuses it), so if the user lands
// // //   // here via a dropdown/menu link that only changes categoryKey, activeCat
// // //   // (and therefore the breadcrumb) would otherwise stay stuck on the old value.
// // //   useEffect(() => {
// // //     setActiveCat(categoryKey);
// // //   }, [categoryKey]);

// // //   useEffect(() => {
// // //     setYear("All");
// // //     setTopic("All");
// // //     setRegion("All");
// // //     setTypeF("All");
// // //     setVisible(6);
// // //   }, [activeCat]);

// // //   const activeMeta = CATEGORY_MAP[activeCat];

// // //   const pool = useMemo(
// // //     () =>
// // //       activeCat === "all"
// // //         ? DOCUMENTS
// // //         : DOCUMENTS.filter((d) => d.category === activeCat),
// // //     [activeCat]
// // //   );
// // //   const maxYear = useMemo(() => Math.max(...pool.map((d) => d.year)), [pool]);

// // //   const filtered = useMemo(() => {
// // //     const q = query.trim().toLowerCase();
// // //     let list = pool.filter((d) => {
// // //       if (year !== "All" && String(d.year) !== String(year)) return false;
// // //       if (topic !== "All" && d.topic !== topic) return false;
// // //       if (region !== "All" && d.region !== region) return false;
// // //       if (typeF !== "All" && d.type !== typeF) return false;
// // //       if (q) {
// // //         const hay = `${d.title} ${d.abstract} ${d.author} ${d.topic} ${d.type}`.toLowerCase();
// // //         if (!hay.includes(q)) return false;
// // //       }
// // //       return true;
// // //     });
// // //     list = [...list].sort((a, b) => {
// // //       if (sort === "az") return a.title.localeCompare(b.title);
// // //       if (sort === "downloads") return b.downloads - a.downloads;
// // //       const da = new Date(a.date).getTime();
// // //       const db = new Date(b.date).getTime();
// // //       return sort === "oldest" ? da - db : db - da;
// // //     });
// // //     return list;
// // //   }, [pool, query, year, topic, region, typeF, sort]);

// // //   const shown = filtered.slice(0, visible);
// // //   const hasMore = visible < filtered.length;

// // //   const activeChips = [];
// // //   if (query.trim()) activeChips.push({ k: "q", label: `“${query.trim()}”`, clear: () => setQuery("") });
// // //   if (year !== "All") activeChips.push({ k: "y", label: `Year: ${year}`, clear: () => setYear("All") });
// // //   if (topic !== "All") activeChips.push({ k: "t", label: topic, clear: () => setTopic("All") });
// // //   if (region !== "All") activeChips.push({ k: "r", label: region, clear: () => setRegion("All") });
// // //   if (typeF !== "All") activeChips.push({ k: "f", label: typeF, clear: () => setTypeF("All") });
// // //   const clearAll = () => {
// // //     setQuery("");
// // //     setYear("All");
// // //     setTopic("All");
// // //     setRegion("All");
// // //     setTypeF("All");
// // //   };

// // //   const trackRef = useRef(null);
// // //   const tabRefs = useRef({});
// // //   const [indicator, setIndicator] = useState({ left: 0, width: 0, ready: false });
// // //   const activeIndex = CATEGORIES.findIndex((c) => c.key === activeCat);
// // //   useLayoutEffect(() => {
// // //     const measure = () => {
// // //       const el = tabRefs.current[activeCat];
// // //       if (el) setIndicator({ left: el.offsetLeft, width: el.offsetWidth, ready: true });
// // //     };
// // //     measure();
// // //     const t = setTimeout(measure, 80);
// // //     window.addEventListener("resize", measure);
// // //     return () => {
// // //       clearTimeout(t);
// // //       window.removeEventListener("resize", measure);
// // //     };
// // //   }, [activeCat, activeIndex]);

// // //   const scrollToGrid = () => {
// // //     document.getElementById("repo-grid")?.scrollIntoView({ behavior: "smooth", block: "start" });
// // //   };

// // //   const selectCls = "flex-1 min-w-[150px]";

// // //   return (
// // //     <main className="overflow-hidden">
// // //       {/* ============================== HERO ============================== */}
// // //       <header id="top" className="relative overflow-hidden bg-[#FAF7F2]">
// // //         {/* backdrop decorations, same as AboutSection */}
// // //         <div className="hero-grid absolute inset-0" />
// // //         <div className="pointer-events-none absolute -top-32 left-1/2 h-[360px] w-[680px] -translate-x-1/2 rounded-full bg-[#DA2128]/10 blur-[130px]" />
// // //         <div className="pointer-events-none absolute -bottom-40 -right-24 h-[320px] w-[320px] rounded-full bg-[#DA2128]/[0.07] blur-[110px]" />

// // //         <Breadcrumb label={activeMeta.label} />

// // //         <div className="relative w-full max-w-[1280px] mx-auto px-6 lg:px-10  pt-28 sm:pt-32">
// // //           <Reveal>
// // //             <div className="max-w-3xl m-auto text-center">
// // //               <div className="inline-flex items-center gap-2.5 rounded-full border border-[#B42318]/15 bg-white/70 backdrop-blur px-4 py-1.5">
// // //                 <span className="w-1.5 h-1.5 rounded-full bg-[#E8590C] animate-pulse" />
// // //                 <span className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-[#B42318]">
// // //                   {meta.eyebrow}
// // //                 </span>
// // //               </div>

// // //               <h1 className="mt-6 font-display text-gray-900 text-4xl sm:text-5xl md:text-[56px] leading-[1.05] tracking-tight [text-wrap:balance]">
// // //                 {meta.title}
// // //               </h1>

// // //               <p className="mt-6 text-gray-600 max-w-2xl leading-relaxed text-[15px] md:text-[16.5px]">
// // //                 {meta.sub}
// // //               </p>
// // //             </div>
// // //           </Reveal>
// // //         </div>

// // //         {/* bottom shimmer line, same as AboutSection */}
// // //         <div className="shimmer-line h-px w-full" />
// // //       </header>

// // //       {/* ====================== FILTER + TABS + GRID ====================== */}
// // //       <section id="repo-grid" className="scroll-mt-24 py-16 md:py-20 bg-[#FAF7F2] relative">
// // //         <div className="absolute inset-0 pointer-events-none">
// // //           <div className="absolute -top-20 right-0 w-80 h-80 rounded-full bg-orange-500/5 blur-3xl" />
// // //           <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-red-700/5 blur-3xl" />
// // //         </div>

// // //         <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">

// // //           {/* ---- category tabs ---- */}
// // //           <Reveal>
// // //             <div className="flex justify-center">
// // //               <div
// // //                 ref={trackRef}
// // //                 className="relative inline-flex items-stretch gap-1 max-w-full overflow-x-auto no-scrollbar rounded-t-2xl bg-white/50 ring-1 ring-orange-200/30 px-2" style={{display: "none"}}
// // //               >
// // //                 {CATEGORIES.map((c) => {
// // //                   const Icon = c.icon;
// // //                   const active = c.key === activeCat;
// // //                   return (
// // //                     <button
// // //                       key={c.key}
// // //                       ref={(el) => (tabRefs.current[c.key] = el)}
// // //                       onClick={() => {
// // //                         setActiveCat(c.key);
// // //                         if (c.key !== categoryKey) {
// // //                           navigate(c.key);
// // //                         }
// // //                       }}
// // //                       className={`relative shrink-0 inline-flex items-center justify-center gap-2 rounded-t-lg px-4 md:px-5 py-3 text-[13.5px] font-semibold whitespace-nowrap leading-none transition-colors duration-200 ${
// // //                         active ? "text-red-700" : "text-gray-500 hover:text-red-700"
// // //                       }`}
// // //                     >
// // //                       <Icon
// // //                         className={`w-4 h-4 shrink-0 transition-colors ${
// // //                           active ? "text-orange-600" : "text-gray-400"
// // //                         }`}
// // //                       />
// // //                       <span>{c.label}</span>
// // //                     </button>
// // //                   );
// // //                 })}
// // //                 <span
// // //                   className="absolute bottom-0 h-[2.5px] rounded-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-300 ease-out"
// // //                   style={{
// // //                     left: indicator.left,
// // //                     width: indicator.width,
// // //                     opacity: indicator.ready ? 1 : 0,
// // //                   }}
// // //                 />
// // //                 <span className="absolute bottom-0 inset-x-2 h-px bg-orange-200/30" />
// // //               </div>
// // //             </div>
// // //           </Reveal>

// // //           {/* ---- filter bar ---- */}
// // //           <Reveal delay={80}>
// // //             <div className="mt-6 bg-white rounded-2xl ring-1 ring-orange-200/30 shadow-sm overflow-hidden">
// // //               <div className="flex items-center gap-3 flex-wrap p-4 md:p-5">
// // //                 <button
// // //                   onClick={() => setFiltersOpen((v) => !v)}
// // //                   className={`inline-flex items-center gap-2 rounded-xl px-3.5 h-10 text-[13px] font-semibold transition-colors ${
// // //                     filtersOpen
// // //                       ? "bg-red-700 text-white shadow-sm shadow-red-700/30"
// // //                       : "bg-[#FAF7F2] text-gray-700 ring-1 ring-orange-200/30 hover:ring-orange-400/60"
// // //                   }`}
// // //                 >
// // //                   <IconSliders className="w-4 h-4" />
// // //                   Filters
// // //                   {activeChips.length > 0 && (
// // //                     <span
// // //                       className={`min-w-[18px] h-[18px] px-1 rounded-full grid place-items-center text-[10px] font-bold ${
// // //                         filtersOpen ? "bg-white/25 text-white" : "bg-red-700 text-white"
// // //                       }`}
// // //                     >
// // //                       {activeChips.length}
// // //                     </span>
// // //                   )}
// // //                 </button>

// // //                 <div className="text-[12.5px] text-gray-500">
// // //                   <span className="font-bold text-gray-800">{filtered.length}</span>{" "}
// // //                   of {pool.length} documents
// // //                 </div>

// // //                 {/* ---- right side: hover-expanding search + sort ---- */}
// // //                 <div className="ml-auto flex items-center gap-2">
// // //                   <HoverSearch
// // //                     query={query}
// // //                     setQuery={setQuery}
// // //                     activeCat={activeCat}
// // //                     onSubmit={scrollToGrid}
// // //                   />

// // //                   <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 hidden sm:inline">Sort</span>
// // //                   <div className="relative">
// // //                     <select
// // //                       value={sort}
// // //                       onChange={(e) => setSort(e.target.value)}
// // //                       className="appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 outline-none text-[13px] font-semibold text-gray-700 pl-3 pr-9 py-2.5 cursor-pointer transition"
// // //                     >
// // //                       <option value="latest">Latest first</option>
// // //                       <option value="oldest">Oldest first</option>
// // //                       <option value="downloads">Most downloaded</option>
// // //                       <option value="az">Title A–Z</option>
// // //                     </select>
// // //                     <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
// // //                   </div>
// // //                 </div>
// // //               </div>

// // //               {/* collapsible filters */}
// // //               <div
// // //                 className={`grid transition-all duration-300 ease-out ${
// // //                   filtersOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
// // //                 }`}
// // //               >
// // //                 <div className="overflow-hidden">
// // //                   <div className="px-4 md:px-5 pb-4 md:pb-5 border-t border-orange-200/30 pt-4 space-y-4">
// // //                     <div className="flex flex-wrap gap-3">
// // //                       <div className={selectCls}>
// // //                         <Select label="Year" value={year} onChange={setYear} options={opts.years.map(String)} allLabel="All years" />
// // //                       </div>
// // //                       <div className={selectCls}>
// // //                         <Select label="Topic" value={topic} onChange={setTopic} options={opts.topics} />
// // //                       </div>
// // //                       <div className={selectCls}>
// // //                         <Select label="Region" value={region} onChange={setRegion} options={opts.regions} />
// // //                       </div>
// // //                     </div>

// // //                     <div className="flex items-center gap-2 flex-wrap">
// // //                       <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Format</span>
// // //                       {["All", ...opts.types].map((t) => {
// // //                         const active = typeF === t;
// // //                         return (
// // //                           <button
// // //                             key={t}
// // //                             onClick={() => setTypeF(t)}
// // //                             className={`rounded-full px-3 py-1 text-[12px] font-semibold ring-1 transition-all duration-200 ${
// // //                               active
// // //                                 ? "bg-red-700 text-white ring-red-700 shadow-sm shadow-red-700/30 scale-[1.03]"
// // //                                 : "bg-white text-gray-600 ring-orange-200/30 hover:ring-orange-400/60 hover:text-red-700"
// // //                             }`}
// // //                           >
// // //                             {t === "All" ? "All formats" : t}
// // //                           </button>
// // //                         );
// // //                       })}
// // //                     </div>

// // //                     {activeChips.length > 0 && (
// // //                       <div className="flex items-center gap-2 flex-wrap pt-1">
// // //                         <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Active</span>
// // //                         {activeChips.map((c) => (
// // //                           <button
// // //                             key={c.k}
// // //                             onClick={c.clear}
// // //                             className="inline-flex items-center gap-1.5 rounded-full bg-orange-100 text-orange-800 ring-1 ring-orange-200/50 pl-3 pr-2 py-1 text-[12px] font-semibold hover:bg-orange-200/50 transition-colors"
// // //                           >
// // //                             {c.label}
// // //                             <span className="w-4 h-4 rounded-full grid place-items-center bg-orange-200/50 hover:bg-orange-600 hover:text-white transition-colors">
// // //                               <IconClose className="w-2.5 h-2.5" stroke={3} />
// // //                             </span>
// // //                           </button>
// // //                         ))}
// // //                         <button
// // //                           onClick={clearAll}
// // //                           className="text-[12px] font-semibold text-red-700 hover:underline underline-offset-2 ml-1"
// // //                         >
// // //                           Clear all
// // //                         </button>
// // //                       </div>
// // //                     )}
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </Reveal>

// // //           {/* ---- results header ---- */}
// // //           <div className="mt-8 flex items-center justify-between gap-4">
// // //             <div className="flex items-center gap-3">
// // //               <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-red-700 to-orange-600 text-white grid place-items-center ring-1 ring-white/20">
// // //                 <CatIcon className="w-[18px] h-[18px]" />
// // //               </span>
// // //               <div>
// // //                 <div className="font-display text-[15px] font-bold text-gray-900">
// // //                   {activeMeta.label}
// // //                 </div>
// // //                 <div className="text-[12px] text-gray-500">{activeMeta.short}</div>
// // //               </div>
// // //             </div>
// // //           </div>

// // //           {/* ---- grid ---- */}
// // //           {filtered.length === 0 ? (
// // //             <Reveal>
// // //               <div className="mt-6 rounded-2xl bg-white ring-1 ring-orange-200/30 p-12 text-center">
// // //                 <div className="mx-auto w-16 h-16 rounded-2xl bg-[#FAF7F2] ring-1 ring-orange-200/30 grid place-items-center text-orange-700">
// // //                   <IconSearch className="w-7 h-7" />
// // //                 </div>
// // //                 <h3 className="mt-5 font-display text-xl text-gray-900">No documents match your filters</h3>
// // //                 <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
// // //                   Try widening the year or region, clearing the format, or resetting your search.
// // //                 </p>
// // //                 <button
// // //                   onClick={clearAll}
// // //                   className="mt-6 inline-flex items-center gap-2 rounded-full bg-red-700 hover:bg-red-800 text-white text-sm font-semibold px-5 py-2.5 transition-colors"
// // //                 >
// // //                   <IconClose className="w-4 h-4" stroke={2.4} /> Clear all filters
// // //                 </button>
// // //               </div>
// // //             </Reveal>
// // //           ) : (
// // //             <>
// // //               <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
// // //                 {shown.map((doc, i) => (
// // //                   <DocCard key={doc.id} doc={doc} index={i} />
// // //                 ))}
// // //               </div>

// // //               {hasMore && (
// // //                 <div className="mt-10 flex justify-center">
// // //                   <button
// // //                     onClick={() => setVisible((v) => v + 6)}
// // //                     className="group inline-flex items-center gap-2.5 rounded-full bg-white ring-1 ring-orange-200/40 hover:ring-orange-500/70 text-gray-800 text-sm font-semibold px-7 py-3.5 shadow-sm hover:shadow-lg hover:shadow-orange-500/10 transition-all"
// // //                   >
// // //                     Load More Research Documents
// // //                     <span className="w-6 h-6 rounded-full grid place-items-center bg-red-700/10 text-red-700 transition-all duration-300 group-hover:bg-red-700 group-hover:text-white group-hover:rotate-180">
// // //                       <IconChevronDown className="w-3.5 h-3.5" stroke={2.6} />
// // //                     </span>
// // //                   </button>
// // //                 </div>
// // //               )}

// // //               {!hasMore && filtered.length > 6 && (
// // //                 <div className="mt-10 text-center text-[12.5px] text-gray-400">
// // //                   You've reached the end of the {activeMeta.label.toLowerCase()} stream.
// // //                 </div>
// // //               )}
// // //             </>
// // //           )}
// // //         </div>
// // //       </section>
// // //     </main>
// // //   );
// // // }




// // // new new code 




// // import React, {
// //   useEffect,
// //   useLayoutEffect,
// //   useMemo,
// //   useRef,
// //   useState,
// // } from "react";
// // import {
// //   IconArrow,
// //   IconDoc,
// //   IconSearch,
// //   IconDownload,
// //   IconChevronDown,
// //   IconCalendar,
// //   IconUser,
// //   IconClose,
// //   IconSliders,
// //   IconLayers,
// //   IconClock,
// //   IconChart,
// // } from "./icons";
// // import {
// //   CATEGORIES,
// //   CATEGORY_MAP,
// //   TYPE_STYLES,
// //   formatDownloads,
// //   formatSize,
// // } from "../data/Research";
// // import {
// //   fetchResearchDocuments,
// //   optionsFor,
// //   openDoc,
// //   downloadDoc,
// // } from "./Researchapi";

// // /* ----------------------------- tiny utilities ---------------------------- */
// // function useInView(opts = {}) {
// //   const ref = useRef(null);
// //   const [inView, setInView] = useState(false);
// //   useEffect(() => {
// //     const el = ref.current;
// //     if (!el) return;
// //     const ob = new IntersectionObserver(
// //       ([e]) => {
// //         if (e.isIntersecting) {
// //           setInView(true);
// //           ob.disconnect();
// //         }
// //       },
// //       { threshold: 0.12, ...opts }
// //     );
// //     ob.observe(el);
// //     return () => ob.disconnect();
// //   }, []);
// //   return [ref, inView];
// // }

// // function Reveal({ children, delay = 0, className = "" }) {
// //   const [ref, inView] = useInView();
// //   return (
// //     <div
// //       ref={ref}
// //       className={`transition-all duration-700 ease-out ${
// //         inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
// //       } ${className}`}
// //       style={{ transitionDelay: `${delay}ms` }}
// //     >
// //       {children}
// //     </div>
// //   );
// // }

// // function CountUp({ value, format = (n) => String(n), duration = 1100 }) {
// //   const [ref, inView] = useInView();
// //   const [display, setDisplay] = useState(0);
// //   const fromRef = useRef(0);
// //   useEffect(() => {
// //     if (!inView) return;
// //     const from = fromRef.current;
// //     const to = value;
// //     const start = performance.now();
// //     let raf;
// //     const tick = (now) => {
// //       const t = Math.min(1, (now - start) / duration);
// //       const eased = 1 - Math.pow(1 - t, 3);
// //       const cur = Math.round(from + (to - from) * eased);
// //       setDisplay(cur);
// //       if (t < 1) raf = requestAnimationFrame(tick);
// //       else fromRef.current = to;
// //     };
// //     raf = requestAnimationFrame(tick);
// //     return () => cancelAnimationFrame(raf);
// //   }, [inView, value, duration]);
// //   return <span ref={ref}>{format(display)}</span>;
// // }

// // /* ------------------------------- document card --------------------------- */
// // function DocCard({ doc, index }) {
// //   const typeCls = TYPE_STYLES[doc.type] || TYPE_STYLES.REPORT;
// //   return (
// //     <Reveal delay={Math.min(index, 8) * 70} className="h-full">
// //       <article className="group relative flex flex-col h-full bg-white rounded-2xl p-6 ring-1 ring-orange-200/50 shadow-sm hover:shadow-2xl hover:shadow-red-900/10 transition-all duration-300 hover:-translate-y-1.5 overflow-hidden">
// //         <span className="absolute top-0 left-0 h-[3px] w-10 rounded-r-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-500 group-hover:w-full" />
// //         <span className="pointer-events-none absolute -top-12 -right-12 w-28 h-28 rounded-full bg-orange-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

// //         <div className="flex items-start gap-4">
// //           <div className="relative w-12 h-12 shrink-0 rounded-xl bg-gradient-to-br from-[#FAF7F2] to-white ring-1 ring-orange-200/30 grid place-items-center text-red-700 transition-all duration-300 group-hover:from-red-700 group-hover:to-orange-600 group-hover:text-white group-hover:scale-105 group-hover:-rotate-3">
// //             <IconDoc className="w-[22px] h-[22px]" />
// //             <span className="absolute -bottom-1.5 -right-1.5 text-[8px] font-extrabold tracking-wider bg-red-700 text-white rounded px-1 py-px ring-2 ring-white group-hover:bg-white group-hover:text-red-700 transition-colors">
// //               PDF
// //             </span>
// //           </div>
// //           <div className="min-w-0 flex-1">
// //             <h3 className="font-display text-[15.5px] leading-snug text-gray-900 line-clamp-2 group-hover:text-red-700 transition-colors duration-200">
// //               {doc.title}
// //             </h3>
// //             <div className="mt-2 flex items-center gap-2 flex-wrap">
// //               <span
// //                 className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ring-1 ${typeCls}`}
// //               >
// //                 {doc.type}
// //               </span>
// //               <span className="text-[10px] font-semibold text-gray-400 inline-flex items-center gap-1">
// //                 <IconLayers className="w-3 h-3" /> {doc.pages} pp
// //               </span>
// //               <span className="text-[10px] font-semibold text-gray-400">
// //                 · {formatSize(doc.sizeKB)}
// //               </span>
// //             </div>
// //           </div>
// //         </div>

// //         <p className="mt-4 text-[13px] leading-relaxed text-gray-600 line-clamp-3">
// //           {doc.abstract}
// //         </p>

// //         <div className="mt-5 grid grid-cols-2 gap-3 border-t border-dashed border-orange-200/30 pt-4">
// //           <div className="min-w-0">
// //             <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
// //               Publication Date
// //             </div>
// //             <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5">
// //               <IconCalendar className="w-3.5 h-3.5 text-orange-700" />
// //               {doc.date}
// //             </div>
// //           </div>
// //           <div className="min-w-0">
// //             <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
// //               Author
// //             </div>
// //             <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5 min-w-0">
// //               <IconUser className="w-3.5 h-3.5 text-orange-700 shrink-0" />
// //               <span className="truncate">{doc.author}</span>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="mt-3 flex items-center gap-1.5 text-[11px] text-gray-400">
// //           <IconDownload className="w-3.5 h-3.5" />
// //           <span className="font-semibold text-gray-500">
// //             {formatDownloads(doc.downloads)}
// //           </span>
// //           <span>downloads</span>
// //           <span className="mx-1 text-gray-300">·</span>
// //           <span>{doc.region}</span>
// //         </div>

// //         <div className="mt-auto pt-5 flex items-stretch gap-2">
// //           <button
// //             onClick={() => openDoc(doc)}
// //             className="group/btn flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-red-700 to-red-800 text-white text-[13px] font-semibold py-2.5 shadow-sm hover:from-orange-600 hover:to-red-700 transition-all duration-300 hover:shadow-lg hover:shadow-red-700/30"
// //           >
// //             <IconDoc className="w-4 h-4" />
// //             View Document
// //           </button>
// //           <button
// //             onClick={() => downloadDoc(doc)}
// //             aria-label={`Download ${doc.title} (PDF)`}
// //             className="w-11 shrink-0 grid place-items-center rounded-lg bg-[#FAF7F2] text-red-700 ring-1 ring-orange-200/30 hover:bg-amber-500 hover:text-white hover:ring-amber-500 transition-all duration-300"
// //           >
// //             <IconDownload className="w-[18px] h-[18px] transition-transform duration-300 group-hover:translate-y-0.5" />
// //           </button>
// //         </div>
// //       </article>
// //     </Reveal>
// //   );
// // }

// // /* ----------------------------- styled select ----------------------------- */
// // function Select({ label, value, onChange, options, allLabel = "All" }) {
// //   return (
// //     <label className="relative block">
// //       <span className="sr-only">{label}</span>
// //       <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[11px] font-bold uppercase tracking-wider text-gray-400 pointer-events-none">
// //         {label}
// //       </span>
// //       <select
// //         value={value}
// //         onChange={(e) => onChange(e.target.value)}
// //         className="w-full appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 focus:bg-white outline-none text-[13px] font-semibold text-gray-700 pl-[68px] pr-9 py-2.5 cursor-pointer transition"
// //       >
// //         <option value="All">{allLabel}</option>
// //         {options.map((o) => (
// //           <option key={o} value={o}>
// //             {o}
// //           </option>
// //         ))}
// //       </select>
// //       <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
// //     </label>
// //   );
// // }

// // /* ------------------------- hover-expanding search ------------------------- */
// // function HoverSearch({ query, setQuery, activeCat, onSubmit }) {
// //   return (
// //     <form
// //       onSubmit={(e) => {
// //         e.preventDefault();
// //         onSubmit?.();
// //       }}
// //       className="group/search relative flex items-center gap-2 rounded-full bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus-within:ring-2 focus-within:ring-orange-500/70 hover:bg-white focus-within:bg-white transition-all duration-300 ease-out h-10 w-10 hover:w-64 focus-within:w-64 pl-2.5 pr-1 overflow-hidden shrink-0"
// //     >
// //       <IconSearch className="w-4 h-4 text-orange-700 shrink-0" />
// //       <input
// //         value={query}
// //         onChange={(e) => setQuery(e.target.value)}
// //         placeholder={`Search ${activeCat === "all" ? "repository" : "stream"}…`}
// //         className="bg-transparent outline-none text-gray-900 placeholder:text-gray-400 text-[13px] w-full min-w-0 opacity-0 group-hover/search:opacity-100 group-focus-within/search:opacity-100 transition-opacity duration-200 delay-100"
// //       />
// //       {query && (
// //         <button
// //           type="button"
// //           onClick={() => setQuery("")}
// //           aria-label="Clear search"
// //           className="w-6 h-6 shrink-0 rounded-full grid place-items-center text-gray-400 hover:bg-gray-100 hover:text-red-700 opacity-0 group-hover/search:opacity-100 group-focus-within/search:opacity-100 transition-opacity duration-200"
// //         >
// //           <IconClose className="w-3.5 h-3.5" stroke={2.4} />
// //         </button>
// //       )}
// //     </form>
// //   );
// // }

// // /* ----------------------------- breadcrumb ----------------------------- */
// // function Breadcrumb({ label }) {
// //   return (
// //     <nav
// //       aria-label="Breadcrumb"
// //       className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
// //     >
// //       <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
// //         <li>
// //           <a
// //             href="/"
// //             className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
// //           >
// //             <svg
// //               viewBox="0 0 24 24"
// //               className="h-4 w-4"
// //               fill="none"
// //               stroke="currentColor"
// //               strokeWidth={2.2}
// //               strokeLinecap="round"
// //               strokeLinejoin="round"
// //             >
// //               <path d="M3 10.5 12 3l9 7.5" />
// //               <path d="M5 10v10h14V10" />
// //               <path d="M9 20v-6h6v6" />
// //             </svg>
// //             Home
// //           </a>
// //         </li>
// //         <li className="text-black/30">&rsaquo;</li>
// //         <li>
// //           <span className="transition-colors duration-300 hover:text-[#DA2128]">
// //             Global Research
// //           </span>
// //         </li>
// //         <li className="text-black/30">&rsaquo;</li>
// //         <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">
// //           {label}
// //         </li>
// //       </ol>
// //     </nav>
// //   );
// // }

// // /* =========================================================================== *
// //  *  REPOSITORY PAGE
// //  * =========================================================================== */
// // export default function ResearchRepository({ categoryKey, navigate, query, setQuery }) {
// //   const meta = CATEGORY_MAP[categoryKey] || CATEGORY_MAP.all;
// //   const CatIcon = meta.icon;

// //   const [activeCat, setActiveCat] = useState(categoryKey);
// //   const [year, setYear] = useState("All");
// //   const [topic, setTopic] = useState("All");
// //   const [region, setRegion] = useState("All");
// //   const [typeF, setTypeF] = useState("All");
// //   const [sort, setSort] = useState("latest");
// //   const [visible, setVisible] = useState(6);
// //   const [filtersOpen, setFiltersOpen] = useState(true);

// //   const [DOCUMENTS, setDocuments] = useState([]);
// //   const [docsLoading, setDocsLoading] = useState(true);
// //   const [docsError, setDocsError] = useState(null);

// //   useEffect(() => {
// //     let cancelled = false;
// //     setDocsLoading(true);
// //     setDocsError(null);
// //     fetchResearchDocuments()
// //       .then((docs) => {
// //         if (!cancelled) setDocuments(docs);
// //       })
// //       .catch((err) => {
// //         if (!cancelled) setDocsError(err.message || "Could not load documents.");
// //       })
// //       .finally(() => {
// //         if (!cancelled) setDocsLoading(false);
// //       });
// //     return () => {
// //       cancelled = true;
// //     };
// //   }, []);

// //   const opts = useMemo(() => optionsFor(DOCUMENTS, activeCat), [DOCUMENTS, activeCat]);

// //   // Keep activeCat in sync with the categoryKey prop — this component doesn't
// //   // remount on route changes (React Router reuses it), so if the user lands
// //   // here via a dropdown/menu link that only changes categoryKey, activeCat
// //   // (and therefore the breadcrumb) would otherwise stay stuck on the old value.
// //   useEffect(() => {
// //     setActiveCat(categoryKey);
// //   }, [categoryKey]);

// //   useEffect(() => {
// //     setYear("All");
// //     setTopic("All");
// //     setRegion("All");
// //     setTypeF("All");
// //     setVisible(6);
// //   }, [activeCat]);

// //   // const activeMeta = CATEGORY_MAP[activeCat];
// //   const activeMeta = CATEGORY_MAP[activeCat] || CATEGORY_MAP.all;

// //   const pool = useMemo(
// //     () =>
// //       activeCat === "all"
// //         ? DOCUMENTS
// //         : DOCUMENTS.filter((d) => d.category === activeCat),
// //     [activeCat, DOCUMENTS]
// //   );
// //   const maxYear = useMemo(
// //     () => (pool.length ? Math.max(...pool.map((d) => d.year)) : new Date().getFullYear()),
// //     [pool]
// //   );

// //   const filtered = useMemo(() => {
// //     const q = query.trim().toLowerCase();
// //     let list = pool.filter((d) => {
// //       if (year !== "All" && String(d.year) !== String(year)) return false;
// //       if (topic !== "All" && d.topic !== topic) return false;
// //       if (region !== "All" && d.region !== region) return false;
// //       if (typeF !== "All" && d.type !== typeF) return false;
// //       if (q) {
// //         const hay = `${d.title} ${d.abstract} ${d.author} ${d.topic} ${d.type}`.toLowerCase();
// //         if (!hay.includes(q)) return false;
// //       }
// //       return true;
// //     });
// //     list = [...list].sort((a, b) => {
// //       if (sort === "az") return a.title.localeCompare(b.title);
// //       if (sort === "downloads") return b.downloads - a.downloads;
// //       const da = new Date(a.date).getTime();
// //       const db = new Date(b.date).getTime();
// //       return sort === "oldest" ? da - db : db - da;
// //     });
// //     return list;
// //   }, [pool, query, year, topic, region, typeF, sort]);

// //   const shown = filtered.slice(0, visible);
// //   const hasMore = visible < filtered.length;

// //   const activeChips = [];
// //   if (query.trim()) activeChips.push({ k: "q", label: `"${query.trim()}"`, clear: () => setQuery("") });
// //   if (year !== "All") activeChips.push({ k: "y", label: `Year: ${year}`, clear: () => setYear("All") });
// //   if (topic !== "All") activeChips.push({ k: "t", label: topic, clear: () => setTopic("All") });
// //   if (region !== "All") activeChips.push({ k: "r", label: region, clear: () => setRegion("All") });
// //   if (typeF !== "All") activeChips.push({ k: "f", label: typeF, clear: () => setTypeF("All") });
// //   const clearAll = () => {
// //     setQuery("");
// //     setYear("All");
// //     setTopic("All");
// //     setRegion("All");
// //     setTypeF("All");
// //   };

// //   const trackRef = useRef(null);
// //   const tabRefs = useRef({});
// //   const [indicator, setIndicator] = useState({ left: 0, width: 0, ready: false });
// //   const activeIndex = CATEGORIES.findIndex((c) => c.key === activeCat);
// //   useLayoutEffect(() => {
// //     const measure = () => {
// //       const el = tabRefs.current[activeCat];
// //       if (el) setIndicator({ left: el.offsetLeft, width: el.offsetWidth, ready: true });
// //     };
// //     measure();
// //     const t = setTimeout(measure, 80);
// //     window.addEventListener("resize", measure);
// //     return () => {
// //       clearTimeout(t);
// //       window.removeEventListener("resize", measure);
// //     };
// //   }, [activeCat, activeIndex]);

// //   const scrollToGrid = () => {
// //     document.getElementById("repo-grid")?.scrollIntoView({ behavior: "smooth", block: "start" });
// //   };

// //   const selectCls = "flex-1 min-w-[150px]";

// //   return (
// //     <main className="overflow-hidden">
// //       {/* ============================== HERO ============================== */}
// //       <header id="top" className="relative overflow-hidden bg-[#FAF7F2]">
// //         {/* backdrop decorations, same as AboutSection */}
// //         <div className="hero-grid absolute inset-0" />
// //         <div className="pointer-events-none absolute -top-32 left-1/2 h-[360px] w-[680px] -translate-x-1/2 rounded-full bg-[#DA2128]/10 blur-[130px]" />
// //         <div className="pointer-events-none absolute -bottom-40 -right-24 h-[320px] w-[320px] rounded-full bg-[#DA2128]/[0.07] blur-[110px]" />

// //         <Breadcrumb label={activeMeta.label} />

// //         <div className="relative w-full max-w-[1280px] mx-auto px-6 lg:px-10  pt-28 sm:pt-32">
// //           <Reveal>
// //             <div className="max-w-3xl m-auto text-center">
// //               <div className="inline-flex items-center gap-2.5 rounded-full border border-[#B42318]/15 bg-white/70 backdrop-blur px-4 py-1.5">
// //                 <span className="w-1.5 h-1.5 rounded-full bg-[#E8590C] animate-pulse" />
// //                 <span className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-[#B42318]">
// //                   {meta.eyebrow}
// //                 </span>
// //               </div>

// //               <h1 className="mt-6 font-display text-gray-900 text-4xl sm:text-5xl md:text-[56px] leading-[1.05] tracking-tight [text-wrap:balance]">
// //                 {meta.title}
// //               </h1>

// //               <p className="mt-6 text-gray-600 max-w-2xl leading-relaxed text-[15px] md:text-[16.5px]">
// //                 {meta.sub}
// //               </p>
// //             </div>
// //           </Reveal>
// //         </div>

// //         {/* bottom shimmer line, same as AboutSection */}
// //         <div className="shimmer-line h-px w-full" />
// //       </header>

// //       {/* ====================== FILTER + TABS + GRID ====================== */}
// //       <section id="repo-grid" className="scroll-mt-24 py-16 md:py-20 bg-[#FAF7F2] relative">
// //         <div className="absolute inset-0 pointer-events-none">
// //           <div className="absolute -top-20 right-0 w-80 h-80 rounded-full bg-orange-500/5 blur-3xl" />
// //           <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-red-700/5 blur-3xl" />
// //         </div>

// //         <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">

// //           {/* ---- category tabs ---- */}
// //           <Reveal>
// //             <div className="flex justify-center">
// //               <div
// //                 ref={trackRef}
// //                 className="relative inline-flex items-stretch gap-1 max-w-full overflow-x-auto no-scrollbar rounded-t-2xl bg-white/50 ring-1 ring-orange-200/30 px-2" style={{display: "none"}}
// //               >
// //                 {CATEGORIES.map((c) => {
// //                   const Icon = c.icon;
// //                   const active = c.key === activeCat;
// //                   return (
// //                     <button
// //                       key={c.key}
// //                       ref={(el) => (tabRefs.current[c.key] = el)}
// //                       onClick={() => {
// //                         setActiveCat(c.key);
// //                         if (c.key !== categoryKey) {
// //                           navigate(c.key);
// //                         }
// //                       }}
// //                       className={`relative shrink-0 inline-flex items-center justify-center gap-2 rounded-t-lg px-4 md:px-5 py-3 text-[13.5px] font-semibold whitespace-nowrap leading-none transition-colors duration-200 ${
// //                         active ? "text-red-700" : "text-gray-500 hover:text-red-700"
// //                       }`}
// //                     >
// //                       <Icon
// //                         className={`w-4 h-4 shrink-0 transition-colors ${
// //                           active ? "text-orange-600" : "text-gray-400"
// //                         }`}
// //                       />
// //                       <span>{c.label}</span>
// //                     </button>
// //                   );
// //                 })}
// //                 <span
// //                   className="absolute bottom-0 h-[2.5px] rounded-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-300 ease-out"
// //                   style={{
// //                     left: indicator.left,
// //                     width: indicator.width,
// //                     opacity: indicator.ready ? 1 : 0,
// //                   }}
// //                 />
// //                 <span className="absolute bottom-0 inset-x-2 h-px bg-orange-200/30" />
// //               </div>
// //             </div>
// //           </Reveal>

// //           {/* ---- filter bar ---- */}
// //           <Reveal delay={80}>
// //             <div className="mt-6 bg-white rounded-2xl ring-1 ring-orange-200/30 shadow-sm overflow-hidden">
// //               <div className="flex items-center gap-3 flex-wrap p-4 md:p-5">
// //                 <button
// //                   onClick={() => setFiltersOpen((v) => !v)}
// //                   className={`inline-flex items-center gap-2 rounded-xl px-3.5 h-10 text-[13px] font-semibold transition-colors ${
// //                     filtersOpen
// //                       ? "bg-red-700 text-white shadow-sm shadow-red-700/30"
// //                       : "bg-[#FAF7F2] text-gray-700 ring-1 ring-orange-200/30 hover:ring-orange-400/60"
// //                   }`}
// //                 >
// //                   <IconSliders className="w-4 h-4" />
// //                   Filters
// //                   {activeChips.length > 0 && (
// //                     <span
// //                       className={`min-w-[18px] h-[18px] px-1 rounded-full grid place-items-center text-[10px] font-bold ${
// //                         filtersOpen ? "bg-white/25 text-white" : "bg-red-700 text-white"
// //                       }`}
// //                     >
// //                       {activeChips.length}
// //                     </span>
// //                   )}
// //                 </button>

// //                 <div className="text-[12.5px] text-gray-500">
// //                   <span className="font-bold text-gray-800">{filtered.length}</span>{" "}
// //                   of {pool.length} documents
// //                 </div>

// //                 {/* ---- right side: hover-expanding search + sort ---- */}
// //                 <div className="ml-auto flex items-center gap-2">
// //                   <HoverSearch
// //                     query={query}
// //                     setQuery={setQuery}
// //                     activeCat={activeCat}
// //                     onSubmit={scrollToGrid}
// //                   />

// //                   <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 hidden sm:inline">Sort</span>
// //                   <div className="relative">
// //                     <select
// //                       value={sort}
// //                       onChange={(e) => setSort(e.target.value)}
// //                       className="appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 outline-none text-[13px] font-semibold text-gray-700 pl-3 pr-9 py-2.5 cursor-pointer transition"
// //                     >
// //                       <option value="latest">Latest first</option>
// //                       <option value="oldest">Oldest first</option>
// //                       <option value="downloads">Most downloaded</option>
// //                       <option value="az">Title A–Z</option>
// //                     </select>
// //                     <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* collapsible filters */}
// //               <div
// //                 className={`grid transition-all duration-300 ease-out ${
// //                   filtersOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
// //                 }`}
// //               >
// //                 <div className="overflow-hidden">
// //                   <div className="px-4 md:px-5 pb-4 md:pb-5 border-t border-orange-200/30 pt-4 space-y-4">
// //                     <div className="flex flex-wrap gap-3">
// //                       <div className={selectCls}>
// //                         <Select label="Year" value={year} onChange={setYear} options={opts.years.map(String)} allLabel="All years" />
// //                       </div>
// //                       <div className={selectCls}>
// //                         <Select label="Topic" value={topic} onChange={setTopic} options={opts.topics} />
// //                       </div>
// //                       <div className={selectCls}>
// //                         <Select label="Region" value={region} onChange={setRegion} options={opts.regions} />
// //                       </div>
// //                     </div>

// //                     <div className="flex items-center gap-2 flex-wrap">
// //                       <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Format</span>
// //                       {["All", ...opts.types].map((t) => {
// //                         const active = typeF === t;
// //                         return (
// //                           <button
// //                             key={t}
// //                             onClick={() => setTypeF(t)}
// //                             className={`rounded-full px-3 py-1 text-[12px] font-semibold ring-1 transition-all duration-200 ${
// //                               active
// //                                 ? "bg-red-700 text-white ring-red-700 shadow-sm shadow-red-700/30 scale-[1.03]"
// //                                 : "bg-white text-gray-600 ring-orange-200/30 hover:ring-orange-400/60 hover:text-red-700"
// //                             }`}
// //                           >
// //                             {t === "All" ? "All formats" : t}
// //                           </button>
// //                         );
// //                       })}
// //                     </div>

// //                     {activeChips.length > 0 && (
// //                       <div className="flex items-center gap-2 flex-wrap pt-1">
// //                         <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Active</span>
// //                         {activeChips.map((c) => (
// //                           <button
// //                             key={c.k}
// //                             onClick={c.clear}
// //                             className="inline-flex items-center gap-1.5 rounded-full bg-orange-100 text-orange-800 ring-1 ring-orange-200/50 pl-3 pr-2 py-1 text-[12px] font-semibold hover:bg-orange-200/50 transition-colors"
// //                           >
// //                             {c.label}
// //                             <span className="w-4 h-4 rounded-full grid place-items-center bg-orange-200/50 hover:bg-orange-600 hover:text-white transition-colors">
// //                               <IconClose className="w-2.5 h-2.5" stroke={3} />
// //                             </span>
// //                           </button>
// //                         ))}
// //                         <button
// //                           onClick={clearAll}
// //                           className="text-[12px] font-semibold text-red-700 hover:underline underline-offset-2 ml-1"
// //                         >
// //                           Clear all
// //                         </button>
// //                       </div>
// //                     )}
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </Reveal>

// //           {/* ---- results header ---- */}
// //           <div className="mt-8 flex items-center justify-between gap-4">
// //             <div className="flex items-center gap-3">
// //               <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-red-700 to-orange-600 text-white grid place-items-center ring-1 ring-white/20">
// //                 <CatIcon className="w-[18px] h-[18px]" />
// //               </span>
// //               <div>
// //                 <div className="font-display text-[15px] font-bold text-gray-900">
// //                   {activeMeta.label}
// //                 </div>
// //                 <div className="text-[12px] text-gray-500">{activeMeta.short}</div>
// //               </div>
// //             </div>
// //           </div>

// //           {/* ---- grid ---- */}
// //           {docsLoading ? (
// //             <Reveal>
// //               <div className="mt-6 rounded-2xl bg-white ring-1 ring-orange-200/30 p-12 text-center">
// //                 <div className="mx-auto w-10 h-10 rounded-full border-2 border-orange-200 border-t-red-700 animate-spin" />
// //                 <p className="mt-4 text-sm text-gray-500">Loading documents…</p>
// //               </div>
// //             </Reveal>
// //           ) : docsError ? (
// //             <Reveal>
// //               <div className="mt-6 rounded-2xl bg-white ring-1 ring-red-200/50 p-12 text-center">
// //                 <p className="text-sm font-semibold text-red-700">Couldn't load documents.</p>
// //                 <p className="mt-1 text-sm text-gray-500">{docsError}</p>
// //               </div>
// //             </Reveal>
// //           ) : filtered.length === 0 ? (
// //             <Reveal>
// //               <div className="mt-6 rounded-2xl bg-white ring-1 ring-orange-200/30 p-12 text-center">
// //                 <div className="mx-auto w-16 h-16 rounded-2xl bg-[#FAF7F2] ring-1 ring-orange-200/30 grid place-items-center text-orange-700">
// //                   <IconSearch className="w-7 h-7" />
// //                 </div>
// //                 <h3 className="mt-5 font-display text-xl text-gray-900">No documents match your filters</h3>
// //                 <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
// //                   Try widening the year or region, clearing the format, or resetting your search.
// //                 </p>
// //                 <button
// //                   onClick={clearAll}
// //                   className="mt-6 inline-flex items-center gap-2 rounded-full bg-red-700 hover:bg-red-800 text-white text-sm font-semibold px-5 py-2.5 transition-colors"
// //                 >
// //                   <IconClose className="w-4 h-4" stroke={2.4} /> Clear all filters
// //                 </button>
// //               </div>
// //             </Reveal>
// //           ) : (
// //             <>
// //               <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
// //                 {shown.map((doc, i) => (
// //                   <DocCard key={doc.id} doc={doc} index={i} />
// //                 ))}
// //               </div>

// //               {hasMore && (
// //                 <div className="mt-10 flex justify-center">
// //                   <button
// //                     onClick={() => setVisible((v) => v + 6)}
// //                     className="group inline-flex items-center gap-2.5 rounded-full bg-white ring-1 ring-orange-200/40 hover:ring-orange-500/70 text-gray-800 text-sm font-semibold px-7 py-3.5 shadow-sm hover:shadow-lg hover:shadow-orange-500/10 transition-all"
// //                   >
// //                     Load More Research Documents
// //                     <span className="w-6 h-6 rounded-full grid place-items-center bg-red-700/10 text-red-700 transition-all duration-300 group-hover:bg-red-700 group-hover:text-white group-hover:rotate-180">
// //                       <IconChevronDown className="w-3.5 h-3.5" stroke={2.6} />
// //                     </span>
// //                   </button>
// //                 </div>
// //               )}

// //               {!hasMore && filtered.length > 6 && (
// //                 <div className="mt-10 text-center text-[12.5px] text-gray-400">
// //                   You've reached the end of the {activeMeta.label.toLowerCase()} stream.
// //                 </div>
// //               )}
// //             </>
// //           )}
// //         </div>
// //       </section>
// //     </main>
// //   );
// // }






// // new new code 







// import React, {
//   useEffect,
//   useLayoutEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import {
//   IconArrow,
//   IconDoc,
//   IconSearch,
//   IconDownload,
//   IconChevronDown,
//   IconCalendar,
//   IconUser,
//   IconClose,
//   IconSliders,
//   IconLayers,
//   IconClock,
//   IconChart,
// } from "./icons";
// import {
//   CATEGORIES,
//   CATEGORY_MAP,
//   TYPE_STYLES,
//   formatDownloads,
//   formatSize,
// } from "../data/Research";
// import {
//   fetchResearchDocuments,
//   optionsFor,
//   openDoc,
//   downloadDoc,
// } from "./Researchapi";

// /* =========================================================================== *
//  *  TIPS  —  buttons + modal
//  *  Sab kuch SIRF TIPS page pe render hota hai, i.e. jab activeCat === "tips"
//  *  <Route path="/global-research/tips"
//  *         element={<ResearchRepositoryPage categoryKey="tips" />} />
//  *  Kisi doosri category / route pe ye buttons ya modal nahi aayenge.
//  * =========================================================================== */

// /* ---- PPTX: apni file ka path yahan set karo -------------------------------
//  * 1) public folder me rakho  -> "/TIPS-Overview.pptx"
//  * 2) ya import karke is file me use karo:
//  *      import tipsPptx from "../assets/TIPS-Overview.pptx";
//  *      const TIPS_PPTX_URL = tipsPptx;
//  * (Vite/CRA dono me ".pptx" import karne ke liye alag config ki zarurat nahi
//  *  hoti — bundler use URL bana deta hai.)
//  * ------------------------------------------------------------------------- */
// const TIPS_PPTX_URL = "https://assocham.org/api/TIPS-Overview.pptx";

// /* OPTIONAL (recommended): same PPTX ka PDF version public folder me rakho.
//    Ye in-page live preview ke liye sabse reliable hai — localhost pe bhi
//    chal jata hai, kisi Microsoft/Google viewer ki zarurat nahi.
//    Nahi rakhna ho to isse "" kar do.                                        */
// const TIPS_PDF_URL = "https://assocham.org/api/TIPS-Overview.pdf";

// /* Microsoft Office Online viewer.
//    Ye SIRF tab chalta hai jab file ek PUBLIC HTTPS URL par ho — viewer ki
//    server-side service file ko internet se fetch karti hai:
//      ✔ public https://...       -> chalega
//      ✘ /TIPS-Overview.pptx      -> relative, viewer kuch fetch nahi kar sakta
//      ✘ http://localhost:5173/.. -> viewer localhost tak pahunch hi nahi sakta
//      ✘ login/interstitial ke peeche -> "couldn't find the file"            */
// const OFFICE_VIEWER = "https://view.officeapps.live.com/op/view.aspx?src=";

// /* URL ko absolute bana kar check karta hai ki Office viewer use pyaar kar
//    payega ya nahi (public HTTPS, localhost/private IP nahi).                 */
// function isOfficeViewable(url) {
//   if (!url) return false;
//   let u;
//   try {
//     u = new URL(url, window.location.href);
//   } catch {
//     return false;
//   }
//   if (u.protocol !== "https:") return false; // http:// bhi viewer reject karta hai
//   const h = u.hostname.toLowerCase();
//   if (h === "localhost" || h === "127.0.0.1" || h === "::1" || h === "[::1]") return false;
//   if (h.endsWith(".localhost") || h.endsWith(".local")) return false;
//   if (/^(127\.|10\.|192\.168\.|169\.254\.|172\.(1[6-9]|2\d|3[01])\.)/.test(h)) return false;
//   return true;
// }

// /* New tab me open — public URL ho to Office viewer, warna file khud.
//    (relative file browser download/preview kar dega)                         */
// function openPptx(url) {
//   if (!url) return;
//   const target = isOfficeViewable(url)
//     ? `${OFFICE_VIEWER}${encodeURIComponent(url)}`
//     : url;
//   window.open(target, "_blank", "noopener,noreferrer");
// }

// /* File download trigger (popup block ho to bhi kaam karta hai)               */
// function downloadFile(url, filename = "TIPS-Overview.pptx") {
//   if (!url) return;
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = filename;
//   a.rel = "noopener";
//   document.body.appendChild(a);
//   a.click();
//   a.remove();
// }

// /* Chhoti si check — file sach me maujood hai ya nahi (same-origin/local pe
//    kaam karta hai; public URL pe CORS ki wajah se fail ho sakta hai).        */
// async function fileExists(url) {
//   if (!url) return false;
//   try {
//     const res = await fetch(url, { method: "HEAD" });
//     return res.ok;
//   } catch {
//     return false;
//   }
// }

// /* ------------------------- TIPS content (data) ---------------------------- */
// const TIPS_INFO = [
//   {
//     key: "about-tips",
//     index: "01",
//     label: "About TIPS",
//     eyebrow: "Trade & Investment Promotion Services",
//     title: "About TIPS",
//     subtitle:
//       "A flagship initiative of the ASSOCHAM Global Research & Strategy Centre (AGRSC)",
//     paragraphs: [
//       "Trade & Investment Promotion Services (TIPS) is a flagship initiative of the ASSOCHAM Global Research & Strategy Centre (AGRSC). It is a one-stop platform for domestic and international investors and exporters, combining the Centre's research depth and policy insight with on-ground facilitation, so that businesses have a single point of contact for trading with or investing in India.",
//       "TIPS supports India's vision of Viksit Bharat @ 2047, aligned with Make in India, Ease of Doing Business and Atmanirbhar Bharat. It aims to facilitate annual FDI of US$ 100 billion into India and to support US$ 1,000 billion in annual merchandise exports and US$ 1,000 billion in annual services exports by 2030.",
//     ],
   
//   },
//   {
//     key: "what-tips-does",
//     index: "02",
//     label: "What TIPS Does",
//     eyebrow: "Facilitator · Advisor · Convenor",
//     title: "What TIPS Does",
//     subtitle:
//       "A multi-dimensional role across India's trade and investment ecosystem",
//     paragraphs: [
//       "TIPS plays a multi-dimensional role as facilitator, advisor and convenor for India's trade and investment ecosystem.",
//     ],
//     items: [
//       {
//         title: "One-Stop Facilitation Platform",
//         text: "A single platform for trade, investment and business collaboration in India, reducing the need to navigate multiple agencies independently.",
//       },
//       {
//         title: "Investment & Regulatory Guidance",
//         text: "Investment facilitation, policy guidance, market intelligence and regulatory support for domestic and international investors.",
//       },
//       {
//         title: "Trade Promotion",
//         text: "Connects businesses with new markets, export opportunities and strategic partners to expand their global and domestic footprint.",
//       },
//       {
//         title: "Stakeholder Engagement",
//         text: "Facilitates engagement between industry, government, financial institutions and global stakeholders on investment and trade challenges.",
//       },
//       {
//         title: "Sectoral & Regional Development",
//         text: "Identifies high-potential investment opportunities across sectors and states to encourage sustainable economic growth.",
//       },
//       {
//         title: "Policy Intelligence",
//         text: "Tracks and disseminates updates on policy reforms and international trade developments for industry and investors.",
//       },
//     ],
//   },
//   {
//     key: "how-tips-supports-investors",
//     index: "03",
//     label: "How TIPS Supports Investors",
//     eyebrow: "Structured support · On-ground engagement",
//     title: "How TIPS Supports Investors",
//     subtitle:
//       "A one-stop reference point for domestic and international investors exploring opportunities in India",
//     paragraphs: [
//       "TIPS is a one-stop reference point for domestic and international investors exploring opportunities in India, offering structured support and active on-ground engagement. TIPS supports investors by:",
//     ],
//     bullets: [
//       "Providing sector-specific and state-specific market intelligence to identify suitable investment opportunities.",
//       "Guiding investors on investment procedures, regulatory approvals, policies and compliance requirements at Central and State levels.",
//       "Facilitating interactions with Central and State Government departments, regulatory authorities and industry stakeholders.",
//       "Assisting in identifying suitable project locations, business partners and joint venture opportunities.",
//       "Undertaking specialised advisory assignments, including market research, financial analysis, due diligence and support for JVs, mergers and acquisitions.",
//       "Providing regular updates on economic developments, sectoral trends, policy reforms, FDI regulations and taxation, with continuous handholding throughout the investment journey.",
//     ],
//   },
// ];

// const TIPS_NAV = TIPS_INFO.map(({ key, label, index }) => ({ key, label, index }));

// /* ----------------------------- tiny utilities ---------------------------- */
// function useInView(opts = {}) {
//   const ref = useRef(null);
//   const [inView, setInView] = useState(false);
//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;
//     const ob = new IntersectionObserver(
//       ([e]) => {
//         if (e.isIntersecting) {
//           setInView(true);
//           ob.disconnect();
//         }
//       },
//       { threshold: 0.12, ...opts }
//     );
//     ob.observe(el);
//     return () => ob.disconnect();
//   }, []);
//   return [ref, inView];
// }

// function Reveal({ children, delay = 0, className = "" }) {
//   const [ref, inView] = useInView();
//   return (
//     <div
//       ref={ref}
//       className={`transition-all duration-700 ease-out ${
//         inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
//       } ${className}`}
//       style={{ transitionDelay: `${delay}ms` }}
//     >
//       {children}
//     </div>
//   );
// }

// function CountUp({ value, format = (n) => String(n), duration = 1100 }) {
//   const [ref, inView] = useInView();
//   const [display, setDisplay] = useState(0);
//   const fromRef = useRef(0);
//   useEffect(() => {
//     if (!inView) return;
//     const from = fromRef.current;
//     const to = value;
//     const start = performance.now();
//     let raf;
//     const tick = (now) => {
//       const t = Math.min(1, (now - start) / duration);
//       const eased = 1 - Math.pow(1 - t, 3);
//       const cur = Math.round(from + (to - from) * eased);
//       setDisplay(cur);
//       if (t < 1) raf = requestAnimationFrame(tick);
//       else fromRef.current = to;
//     };
//     raf = requestAnimationFrame(tick);
//     return () => cancelAnimationFrame(raf);
//   }, [inView, value, duration]);
//   return <span ref={ref}>{format(display)}</span>;
// }

// /* Small triangle arrow — same mark used in the Leadership modal/buttons */
// function TipsArrow({ className = "h-2.5 w-2" }) {
//   return (
//     <svg viewBox="0 0 8 12" className={`${className} flex-shrink-0 fill-[#f47b20]`} aria-hidden="true">
//       <polygon points="0,0 8,6 0,12" />
//     </svg>
//   );
// }

// /* PPTX file icon (slide + play mark) */
// function IconPptx({ className = "h-4 w-4" }) {
//   return (
//     <svg
//       viewBox="0 0 24 24"
//       className={className}
//       fill="none"
//       stroke="currentColor"
//       strokeWidth={1.9}
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       aria-hidden="true"
//     >
//       <path d="M3 4.5h18v12H3z" />
//       <path d="M12 16.5V21" />
//       <path d="M8.5 21h7" />
//       <path d="M10.2 13.2V7.8h2.1a1.9 1.9 0 0 1 0 3.8h-2.1" />
//     </svg>
//   );
// }

// /* =========================================================================== *
//  *  TIPS INFO MODAL  —  Leadership BioModal jaisa hi look / behaviour
//  *  (cream panel, 4px grey frame, orange accents, numbered index, X bar,
//  *   scrollable body, Escape + backdrop close, scroll lock)
//  * =========================================================================== */
// function TipsInfoModal({ item, items = [], onClose, onSelect }) {
//   useEffect(() => {
//     if (!item) return;

//     const handleKeyDown = (e) => {
//       if (e.key === "Escape") onClose();
//     };

//     document.addEventListener("keydown", handleKeyDown);
//     const previousOverflow = document.body.style.overflow;
//     document.body.style.overflow = "hidden";

//     return () => {
//       document.removeEventListener("keydown", handleKeyDown);
//       document.body.style.overflow = previousOverflow;
//     };
//   }, [item, onClose]);

//   if (!item) return null;

//   const activeIndex = items.findIndex((i) => i.key === item.key);

//   return (
//     <div
//       className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#0a2c5c]/70 px-4 py-8 backdrop-blur-sm"
//       onClick={onClose}
//       role="dialog"
//       aria-modal="true"
//       aria-labelledby="tips-modal-title"
//     >
//       <div
//         className="relative flex max-h-[85vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl border-4 border-[#dddfe1] bg-[#f3ece2] shadow-2xl"
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* ---------------- Header (index + title + X bar) ---------------- */}
//         <div className="flex items-start justify-between gap-4 border-b-2 border-[#f47b20]/30 bg-[#f3ece2] px-6 py-5 sm:px-8">
//           <div className="flex items-start gap-4">
//             <span className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full border-2 border-[#f47b20] bg-white text-lg font-extrabold text-[#f47b20]">
//               {item.index}
//             </span>
//             <div className="min-w-0">
//               <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#0a2c5c]/60">
//                 {item.eyebrow}
//               </p>
//               <h3
//                 id="tips-modal-title"
//                 className="mt-1 text-lg font-extrabold leading-tight text-[#0a2c5c] sm:text-xl"
//               >
//                 {item.title}
//               </h3>
//               {item.subtitle && (
//                 <p className="mt-1 text-sm font-semibold leading-snug text-[#f47b20]">
//                   {item.subtitle}
//                 </p>
//               )}
//             </div>
//           </div>
//           <button
//             type="button"
//             onClick={onClose}
//             aria-label="Close TIPS information"
//             className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border-2 border-[#f47b20] text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
//           >
//             <svg
//               viewBox="0 0 24 24"
//               className="h-4 w-4"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2.5}
//               strokeLinecap="round"
//             >
//               <path d="M6 6l12 12M18 6L6 18" />
//             </svg>
//           </button>
//         </div>

//         {/* ------------------------------ Body ----------------------------- */}
//         <div className="space-y-5 overflow-y-auto px-6 py-6 text-sm leading-relaxed text-[#0a2c5c]/90 sm:px-8 sm:text-base">
//           {item.paragraphs?.map((p, i) => (
//             <p key={`p-${i}`}>{p}</p>
//           ))}

//           {item.stats?.length > 0 && (
//             <div className="grid gap-3 sm:grid-cols-3">
//               {item.stats.map((s) => (
//                 <div
//                   key={s.label}
//                   className="rounded-xl border-2 border-[#dddfe1] bg-white px-4 py-3"
//                 >
//                   <p className="text-[15px] font-extrabold leading-tight text-[#f47b20]">
//                     {s.value}
//                   </p>
//                   <p className="mt-1 text-[11px] font-bold uppercase tracking-wide text-[#0a2c5c]/70">
//                     {s.label}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           )}

//           {item.pointers?.length > 0 && (
//             <ul className="space-y-2.5">
//               {item.pointers.map((p, i) => (
//                 <li key={`pt-${i}`} className="flex items-start gap-3">
//                   <span className="mt-[7px] flex h-4 w-4 flex-shrink-0 items-center justify-center">
//                     <TipsArrow className="h-2.5 w-2" />
//                   </span>
//                   <span className="text-[13.5px] font-semibold leading-relaxed text-[#0a2c5c] sm:text-[14.5px]">
//                     {p}
//                   </span>
//                 </li>
//               ))}
//             </ul>
//           )}

//           {item.items?.length > 0 && (
//             <ol className="space-y-3">
//               {item.items.map((it, i) => (
//                 <li
//                   key={it.title}
//                   className="flex gap-4 rounded-xl border-2 border-[#dddfe1] bg-white p-4"
//                 >
//                   <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#EE8202] text-[12px] font-extrabold text-white">
//                     {String(i + 1).padStart(2, "0")}
//                   </span>
//                   <div className="min-w-0">
//                     <p className="text-[14.5px] font-bold leading-snug text-[#0a2c5c]">
//                       {it.title}
//                     </p>
//                     <p className="mt-1 text-[13.5px] leading-relaxed text-[#0a2c5c]/85">
//                       {it.text}
//                     </p>
//                   </div>
//                 </li>
//               ))}
//             </ol>
//           )}

//           {item.bullets?.length > 0 && (
//             <ul className="space-y-2.5">
//               {item.bullets.map((b, i) => (
//                 <li key={`b-${i}`} className="flex items-start gap-3">
//                   <span className="mt-[2px] flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#f47b20]/15 text-[11px] font-extrabold text-[#f47b20]">
//                     {String(i + 1).padStart(2, "0")}
//                   </span>
//                   <span className="text-[13.5px] leading-relaxed text-[#0a2c5c]/90 sm:text-[14.5px]">
//                     {b}
//                   </span>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>

//         {/* --------------- Footer: section index switcher + close ------------ */}
//         <div className="flex flex-wrap items-center justify-between gap-3 border-t-2 border-[#f47b20]/30 bg-[#f3ece2] px-6 py-4 sm:px-8">
//           <div className="flex items-center gap-2">
//             <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#0a2c5c]/50">
//               Section
//             </span>
//             {items.map((it) => {
//               const active = it.key === item.key;
//               return (
//                 <button
//                   key={it.key}
//                   type="button"
//                   onClick={() => onSelect?.(it.key)}
//                   aria-label={it.label}
//                   aria-current={active ? "true" : undefined}
//                   className={`h-8 w-8 rounded-full border-2 text-[12px] font-extrabold transition-colors ${
//                     active
//                       ? "border-[#f47b20] bg-[#f47b20] text-white"
//                       : "border-[#dddfe1] bg-white text-[#0a2c5c] hover:border-[#f47b20] hover:text-[#f47b20]"
//                   }`}
//                 >
//                   {it.index}
//                 </button>
//               );
//             })}
//             {activeIndex >= 0 && (
//               <span className="ml-1 text-[12px] font-bold text-[#0a2c5c]/50">
//                 {activeIndex + 1} / {items.length}
//               </span>
//             )}
//           </div>

//           <button
//             type="button"
//             onClick={onClose}
//             className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-transparent px-5 py-2.5 text-sm font-bold text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
//           >
//             <span>Close</span>
//             <TipsArrow />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ------------------- TIPS quick-nav (3 buttons — CLICK only) -------------- */
// function TipsQuickNav({ items = [], activeKey, onSelect }) {
//   return (
//     <nav aria-label="TIPS information" className="min-w-0">
//       <ul className="flex items-center gap-1 rounded-full bg-[#FAF7F2] ring-1 ring-orange-200/30 p-1 max-w-full overflow-x-auto no-scrollbar">
//         {items.map((it) => {
//           const active = it.key === activeKey;
//           return (
//             <li key={it.key} className="shrink-0">
//               <button
//                 type="button"
//                 onClick={() => onSelect?.(it.key)}
//                 aria-haspopup="dialog"
//                 aria-current={active ? "true" : undefined}
//                 className={`whitespace-nowrap rounded-full px-3.5 h-8 text-[12.5px] font-semibold leading-none transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/70 ${
//                   active
//                     ? "bg-gradient-to-r from-red-700 to-orange-600 text-white shadow-sm shadow-red-700/30"
//                     : "bg-transparent text-gray-600 hover:bg-white hover:text-red-700"
//                 }`}
//               >
//                 {it.label}
//               </button>
//             </li>
//           );
//         })}
//       </ul>
//     </nav>
//   );
// }

// /* -------------------------- Explore more (PPTX) -------------------------- */
// function ExploreMoreButton({ onClick, label = "Explore more" }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       aria-label={`${label} — open TIPS presentation (PPTX)`}
//       className="group/explore inline-flex h-10 items-center gap-2.5 rounded-full bg-gradient-to-r from-red-700 to-orange-600 pl-4 pr-3 text-[13px] font-semibold text-white shadow-sm shadow-red-700/30 transition-all duration-300 hover:from-orange-600 hover:to-amber-500 hover:shadow-lg hover:shadow-red-700/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/70"
//     >
//       <IconPptx className="h-[18px] w-[18px]" />
//       <span>{label}</span>
//       <span className="rounded bg-white/20 px-1.5 py-0.5 text-[9px] font-extrabold tracking-wider ring-1 ring-white/25">
//         PPTX
//       </span>
//       <span className="grid h-6 w-6 place-items-center rounded-full bg-white/20 transition-transform duration-300 group-hover/explore:translate-x-0.5">
//         <TipsArrow className="h-2.5 w-2 fill-white" />
//       </span>
//     </button>
//   );
// }

// /* =========================================================================== *
//  *  PPTX VIEWER MODAL  —  "Explore more"
//  *  Live preview ke 3 modes, order of preference:
//  *   1. "pdf"     -> TIPS_PDF_URL mile to in-page iframe  (localhost pe bhi live)
//  *   2. "office"  -> file public HTTPS hai to Microsoft Office viewer iframe
//  *   3. "local" / "missing" -> file local/relative hai (ya nahi mili) to
//  *                   saaf message + Download / Open buttons
//  * =========================================================================== */
// function PptxModal({
//   open,
//   url = TIPS_PPTX_URL,
//   pdfUrl = TIPS_PDF_URL,
//   onClose,
//   fileName = "/TIPS-Overview.pptx",
// }) {
//   const [mode, setMode] = useState("checking"); // checking | pdf | office | local | missing

//   const canOffice = isOfficeViewable(url);
//   const officeSrc = canOffice ? `${OFFICE_VIEWER}${encodeURIComponent(url)}` : "";

//   /* body scroll lock + Escape */
//   useEffect(() => {
//     if (!open) return;
//     const onKey = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", onKey);
//     const prev = document.body.style.overflow;
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.removeEventListener("keydown", onKey);
//       document.body.style.overflow = prev;
//     };
//   }, [open, onClose]);

//   /* decide mode */
//   useEffect(() => {
//     if (!open) return;
//     let cancelled = false;
//     setMode("checking");

//     (async () => {
//       // 1) PDF hai? -> in-page live preview (sabse reliable)
//       if (pdfUrl && (await fileExists(pdfUrl))) {
//         if (!cancelled) setMode("pdf");
//         return;
//       }
//       // 2) public https file? -> Office viewer
//       if (canOffice) {
//         if (!cancelled) setMode("office");
//         return;
//       }
//       // 3) local/relative file hai to download batao, warna missing
//       const exists = await fileExists(url);
//       if (!cancelled) setMode(exists ? "local" : "missing");
//     })();

//     return () => {
//       cancelled = true;
//     };
//   }, [open, url, pdfUrl, canOffice]);

//   if (!open) return null;

//   const isLocalHost =
//     typeof window !== "undefined" &&
//     /^(localhost|127\.0\.0\.1|\[::1\])$/i.test(window.location.hostname);

//   return (
//     <div
//       className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#0a2c5c]/70 px-4 py-8 backdrop-blur-sm"
//       onClick={onClose}
//       role="dialog"
//       aria-modal="true"
//       aria-labelledby="pptx-modal-title"
//     >
//       <div
//         className="relative flex max-h-[90vh] w-full max-w-4xl flex-col overflow-hidden rounded-2xl border-4 border-[#dddfe1] bg-[#f3ece2] shadow-2xl"
//         style={{ minHeight: "min(560px, 80vh)" }}
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* Header */}
//         <div className="flex items-start justify-between gap-4 border-b-2 border-[#f47b20]/30 bg-[#f3ece2] px-6 py-5 sm:px-8">
//           <div className="flex items-start gap-4">
//             <span className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full border-2 border-[#f47b20] bg-white text-[#f47b20]">
//               <IconPptx className="h-6 w-6" />
//             </span>
//             <div className="min-w-0">
//               <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#0a2c5c]/60">
//                 Trade &amp; Investment Promotion Services
//               </p>
//               <h3
//                 id="pptx-modal-title"
//                 className="mt-1 text-lg font-extrabold leading-tight text-[#0a2c5c] sm:text-xl"
//               >
//                 TIPS — Presentation
//               </h3>
//               <p className="mt-1 text-sm font-semibold leading-snug text-[#f47b20]">
//                 {mode === "pdf"
//                   ? "Live preview (PDF)"
//                   : mode === "office"
//                   ? "Live preview via Microsoft Office Online"
//                   : mode === "local"
//                   ? "Presentation file ready to download"
//                   : mode === "missing"
//                   ? "Presentation file not found"
//                   : "Loading preview…"}
//               </p>
//             </div>
//           </div>
//           <button
//             type="button"
//             onClick={onClose}
//             aria-label="Close presentation"
//             className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border-2 border-[#f47b20] text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
//           >
//             <svg
//               viewBox="0 0 24 24"
//               className="h-4 w-4"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2.5}
//               strokeLinecap="round"
//             >
//               <path d="M6 6l12 12M18 6L6 18" />
//             </svg>
//           </button>
//         </div>

//         {/* Body */}
//         <div className="flex-1 overflow-y-auto bg-white/40 p-4 sm:p-5">
//           {mode === "checking" && (
//             <div className="grid h-full min-h-[320px] place-items-center">
//               <div className="text-center">
//                 <div className="mx-auto h-10 w-10 rounded-full border-2 border-[#f47b20]/30 border-t-[#f47b20] animate-spin" />
//                 <p className="mt-4 text-sm text-[#0a2c5c]/70">
//                   Presentation khul rahi hai…
//                 </p>
//               </div>
//             </div>
//           )}

//           {(mode === "pdf" || mode === "office") && (
//             <iframe
//               key={mode}
//               src={mode === "pdf" ? pdfUrl : officeSrc}
//               title="TIPS presentation"
//               className="h-[58vh] w-full rounded-xl border-2 border-[#dddfe1] bg-white"
//             />
//           )}

//           {(mode === "local" || mode === "missing") && (
//             <div className="grid min-h-[320px] place-items-center">
//               <div className="max-w-lg rounded-2xl border-2 border-[#dddfe1] bg-white p-6 text-center">
//                 <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-[#f47b20]/10 text-[#f47b20]">
//                   <IconPptx className="h-7 w-7" />
//                 </div>

//                 <h4 className="mt-4 text-base font-extrabold text-[#0a2c5c]">
//                   {mode === "missing"
//                     ? "File nahi mili — 404"
//                     : "Local build me live preview possible nahi"}
//                 </h4>

//                 <p className="mt-2 text-[13.5px] leading-relaxed text-[#0a2c5c]/80">
//                   {mode === "missing" ? (
//                     <>
//                       <code className="rounded bg-[#f3ece2] px-1.5 py-0.5 text-[12.5px] font-semibold">
//                         {url}
//                       </code>{" "}
//                       par kuch nahi hai. File ko <b>public/</b> folder me rakho
//                       (naam exactly match hona chahiye, Linux pe case-sensitive).
//                     </>
//                   ) : (
//                     <>
//                       Microsoft Office viewer sirf <b>public HTTPS</b> file ko
//                       kholta hai — {isLocalHost ? "localhost" : "ye host"} tak
//                       uski service pahunch hi nahi sakti. File yahin se download
//                       kar lo, ya in-page live preview ke liye PDF version use karo.
//                     </>
//                   )}
//                 </p>

//                 <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
//                   <button
//                     type="button"
//                     onClick={() => downloadFile(url, fileName)}
//                     className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-[#f47b20] px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#e06b12]"
//                   >
//                     <span>Download PPTX</span>
//                     <TipsArrow className="h-2.5 w-2 fill-white" />
//                   </button>
//                   <button
//                     type="button"
//                     onClick={() => openPptx(url)}
//                     className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-transparent px-5 py-2.5 text-sm font-bold text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
//                   >
//                     <span>Open in new tab</span>
//                     <TipsArrow />
//                   </button>
//                 </div>

//                 {mode === "local" && (
//                   <ul className="mt-5 space-y-2 text-left text-[12.5px] leading-relaxed text-[#0a2c5c]/75">
//                     <li>
//                       <b>Live preview chahiye?</b> PPTX ko PDF me convert karke{" "}
//                       <code className="rounded bg-[#f3ece2] px-1 py-0.5">public/TIPS-Overview.pdf</code>{" "}
//                       rakh do — modal use khud iframe me dikha dega (
//                       <code className="rounded bg-[#f3ece2] px-1 py-0.5">TIPS_PDF_URL</code>).
//                     </li>
//                     <li>
//                       <b>Ya</b> PPTX ko HTTPS server par upload karke{" "}
//                       <code className="rounded bg-[#f3ece2] px-1 py-0.5">TIPS_PPTX_URL</code>{" "}
//                       me poora URL daal do — tab Office viewer live khulega.
//                     </li>
//                   </ul>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="flex flex-wrap items-center justify-between gap-3 border-t-2 border-[#f47b20]/30 bg-[#f3ece2] px-6 py-4 sm:px-8">
//           <span className="text-[11px] font-semibold text-[#0a2c5c]/60">
//             {fileName}
//           </span>
//           <div className="flex flex-wrap items-center gap-3">
//             <button
//               type="button"
//               onClick={() => downloadFile(url, fileName)}
//               className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-transparent px-4 py-2 text-[13px] font-bold text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
//             >
//               <IconDownload className="h-4 w-4" />
//               <span>Download</span>
//             </button>
//             {isOfficeViewable(url) && (
//               <button
//                 type="button"
//                 onClick={() => openPptx(url)}
//                 className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-transparent px-4 py-2 text-[13px] font-bold text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
//               >
//                 <span>Open in new tab</span>
//                 <TipsArrow />
//               </button>
//             )}
//             <button
//               type="button"
//               onClick={onClose}
//               className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-transparent px-5 py-2 text-[13px] font-bold text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
//             >
//               <span>Close</span>
//               <TipsArrow />
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ------------------------------- document card --------------------------- */
// function DocCard({ doc, index }) {
//   const typeCls = TYPE_STYLES[doc.type] || TYPE_STYLES.REPORT;
//   return (
//     <Reveal delay={Math.min(index, 8) * 70} className="h-full">
//       <article className="group relative flex flex-col h-full bg-white rounded-2xl p-6 ring-1 ring-orange-200/50 shadow-sm hover:shadow-2xl hover:shadow-red-900/10 transition-all duration-300 hover:-translate-y-1.5 overflow-hidden">
//         <span className="absolute top-0 left-0 h-[3px] w-10 rounded-r-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-500 group-hover:w-full" />
//         <span className="pointer-events-none absolute -top-12 -right-12 w-28 h-28 rounded-full bg-orange-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

//         <div className="flex items-start gap-4">
//           <div className="relative w-12 h-12 shrink-0 rounded-xl bg-gradient-to-br from-[#FAF7F2] to-white ring-1 ring-orange-200/30 grid place-items-center text-red-700 transition-all duration-300 group-hover:from-red-700 group-hover:to-orange-600 group-hover:text-white group-hover:scale-105 group-hover:-rotate-3">
//             <IconDoc className="w-[22px] h-[22px]" />
//             <span className="absolute -bottom-1.5 -right-1.5 text-[8px] font-extrabold tracking-wider bg-red-700 text-white rounded px-1 py-px ring-2 ring-white group-hover:bg-white group-hover:text-red-700 transition-colors">
//               PDF
//             </span>
//           </div>
//           <div className="min-w-0 flex-1">
//             <h3 className="font-display text-[15.5px] leading-snug text-gray-900 line-clamp-2 group-hover:text-red-700 transition-colors duration-200">
//               {doc.title}
//             </h3>
//             <div className="mt-2 flex items-center gap-2 flex-wrap">
//               <span
//                 className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ring-1 ${typeCls}`}
//               >
//                 {doc.type}
//               </span>
//               <span className="text-[10px] font-semibold text-gray-400 inline-flex items-center gap-1">
//                 <IconLayers className="w-3 h-3" /> {doc.pages} pp
//               </span>
//               <span className="text-[10px] font-semibold text-gray-400">
//                 · {formatSize(doc.sizeKB)}
//               </span>
//             </div>
//           </div>
//         </div>

//         <p className="mt-4 text-[13px] leading-relaxed text-gray-600 line-clamp-3">
//           {doc.abstract}
//         </p>

//         <div className="mt-5 grid grid-cols-2 gap-3 border-t border-dashed border-orange-200/30 pt-4">
//           <div className="min-w-0">
//             <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
//               Publication Date
//             </div>
//             <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5">
//               <IconCalendar className="w-3.5 h-3.5 text-orange-700" />
//               {doc.date}
//             </div>
//           </div>
//           <div className="min-w-0">
//             <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
//               Author
//             </div>
//             <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5 min-w-0">
//               <IconUser className="w-3.5 h-3.5 text-orange-700 shrink-0" />
//               <span className="truncate">{doc.author}</span>
//             </div>
//           </div>
//         </div>

//         <div className="mt-3 flex items-center gap-1.5 text-[11px] text-gray-400">
//           <IconDownload className="w-3.5 h-3.5" />
//           <span className="font-semibold text-gray-500">
//             {formatDownloads(doc.downloads)}
//           </span>
//           <span>downloads</span>
//           <span className="mx-1 text-gray-300">·</span>
//           <span>{doc.region}</span>
//         </div>

//         <div className="mt-auto pt-5 flex items-stretch gap-2">
//           <button
//             onClick={() => openDoc(doc)}
//             className="group/btn flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-red-700 to-red-800 text-white text-[13px] font-semibold py-2.5 shadow-sm hover:from-orange-600 hover:to-red-700 transition-all duration-300 hover:shadow-lg hover:shadow-red-700/30"
//           >
//             <IconDoc className="w-4 h-4" />
//             View Document
//           </button>
//           <button
//             onClick={() => downloadDoc(doc)}
//             aria-label={`Download ${doc.title} (PDF)`}
//             className="w-11 shrink-0 grid place-items-center rounded-lg bg-[#FAF7F2] text-red-700 ring-1 ring-orange-200/30 hover:bg-amber-500 hover:text-white hover:ring-amber-500 transition-all duration-300"
//           >
//             <IconDownload className="w-[18px] h-[18px] transition-transform duration-300 group-hover:translate-y-0.5" />
//           </button>
//         </div>
//       </article>
//     </Reveal>
//   );
// }

// /* ----------------------------- styled select ----------------------------- */
// function Select({ label, value, onChange, options, allLabel = "All" }) {
//   return (
//     <label className="relative block">
//       <span className="sr-only">{label}</span>
//       <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[11px] font-bold uppercase tracking-wider text-gray-400 pointer-events-none">
//         {label}
//       </span>
//       <select
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         className="w-full appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 focus:bg-white outline-none text-[13px] font-semibold text-gray-700 pl-[68px] pr-9 py-2.5 cursor-pointer transition"
//       >
//         <option value="All">{allLabel}</option>
//         {options.map((o) => (
//           <option key={o} value={o}>
//             {o}
//           </option>
//         ))}
//       </select>
//       <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
//     </label>
//   );
// }

// /* ------------------------- hover-expanding search ------------------------- */
// function HoverSearch({ query, setQuery, activeCat, onSubmit }) {
//   return (
//     <form
//       onSubmit={(e) => {
//         e.preventDefault();
//         onSubmit?.();
//       }}
//       className="group/search relative flex items-center gap-2 rounded-full bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus-within:ring-2 focus-within:ring-orange-500/70 hover:bg-white focus-within:bg-white transition-all duration-300 ease-out h-10 w-10 hover:w-64 focus-within:w-64 pl-2.5 pr-1 overflow-hidden shrink-0"
//     >
//       <IconSearch className="w-4 h-4 text-orange-700 shrink-0" />
//       <input
//         value={query}
//         onChange={(e) => setQuery(e.target.value)}
//         placeholder={`Search ${activeCat === "all" ? "repository" : "stream"}…`}
//         className="bg-transparent outline-none text-gray-900 placeholder:text-gray-400 text-[13px] w-full min-w-0 opacity-0 group-hover/search:opacity-100 group-focus-within/search:opacity-100 transition-opacity duration-200 delay-100"
//       />
//       {query && (
//         <button
//           type="button"
//           onClick={() => setQuery("")}
//           aria-label="Clear search"
//           className="w-6 h-6 shrink-0 rounded-full grid place-items-center text-gray-400 hover:bg-gray-100 hover:text-red-700 opacity-0 group-hover/search:opacity-100 group-focus-within/search:opacity-100 transition-opacity duration-200"
//         >
//           <IconClose className="w-3.5 h-3.5" stroke={2.4} />
//         </button>
//       )}
//     </form>
//   );
// }

// /* ----------------------------- breadcrumb ----------------------------- */
// function Breadcrumb({ label }) {
//   return (
//     <nav
//       aria-label="Breadcrumb"
//       className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
//     >
//       <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
//         <li>
//           <a
//             href="/"
//             className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
//           >
//             <svg
//               viewBox="0 0 24 24"
//               className="h-4 w-4"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2.2}
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path d="M3 10.5 12 3l9 7.5" />
//               <path d="M5 10v10h14V10" />
//               <path d="M9 20v-6h6v6" />
//             </svg>
//             Home
//           </a>
//         </li>
//         <li className="text-black/30">&rsaquo;</li>
//         <li>
//           <span className="transition-colors duration-300 hover:text-[#DA2128]">
//             Global Research
//           </span>
//         </li>
//         <li className="text-black/30">&rsaquo;</li>
//         <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">
//           {label}
//         </li>
//       </ol>
//     </nav>
//   );
// }

// /* =========================================================================== *
//  *  REPOSITORY PAGE
//  * =========================================================================== */
// export default function ResearchRepository({
//   categoryKey,
//   navigate,
//   query,
//   setQuery,
// }) {
//   const meta = CATEGORY_MAP[categoryKey] || CATEGORY_MAP.all;
//   const CatIcon = meta.icon;

//   const [activeCat, setActiveCat] = useState(categoryKey);
//   const [year, setYear] = useState("All");
//   const [topic, setTopic] = useState("All");
//   const [region, setRegion] = useState("All");
//   const [typeF, setTypeF] = useState("All");
//   const [sort, setSort] = useState("latest");
//   const [visible, setVisible] = useState(6);
//   const [filtersOpen, setFiltersOpen] = useState(true);

//   const [DOCUMENTS, setDocuments] = useState([]);
//   const [docsLoading, setDocsLoading] = useState(true);
//   const [docsError, setDocsError] = useState(null);

//   useEffect(() => {
//     let cancelled = false;
//     setDocsLoading(true);
//     setDocsError(null);
//     fetchResearchDocuments()
//       .then((docs) => {
//         if (!cancelled) setDocuments(docs);
//       })
//       .catch((err) => {
//         if (!cancelled) setDocsError(err.message || "Could not load documents.");
//       })
//       .finally(() => {
//         if (!cancelled) setDocsLoading(false);
//       });
//     return () => {
//       cancelled = true;
//     };
//   }, []);

//   const opts = useMemo(() => optionsFor(DOCUMENTS, activeCat), [DOCUMENTS, activeCat]);

//   // Keep activeCat in sync with the categoryKey prop — this component doesn't
//   // remount on route changes (React Router reuses it), so if the user lands
//   // here via a dropdown/menu link that only changes categoryKey, activeCat
//   // (and therefore the breadcrumb) would otherwise stay stuck on the old value.
//   useEffect(() => {
//     setActiveCat(categoryKey);
//   }, [categoryKey]);

//   useEffect(() => {
//     setYear("All");
//     setTopic("All");
//     setRegion("All");
//     setTypeF("All");
//     setVisible(6);
//   }, [activeCat]);

//   // const activeMeta = CATEGORY_MAP[activeCat];
//   const activeMeta = CATEGORY_MAP[activeCat] || CATEGORY_MAP.all;

//   /* ---------------- TIPS gate: sirf TIPS page / route pe ---------------- */
//   const isTipsPage = activeCat === "tips";

//   const pool = useMemo(
//     () =>
//       activeCat === "all"
//         ? DOCUMENTS
//         : DOCUMENTS.filter((d) => d.category === activeCat),
//     [activeCat, DOCUMENTS]
//   );
//   const maxYear = useMemo(
//     () => (pool.length ? Math.max(...pool.map((d) => d.year)) : new Date().getFullYear()),
//     [pool]
//   );

//   const filtered = useMemo(() => {
//     const q = query.trim().toLowerCase();
//     let list = pool.filter((d) => {
//       if (year !== "All" && String(d.year) !== String(year)) return false;
//       if (topic !== "All" && d.topic !== topic) return false;
//       if (region !== "All" && d.region !== region) return false;
//       if (typeF !== "All" && d.type !== typeF) return false;
//       if (q) {
//         const hay = `${d.title} ${d.abstract} ${d.author} ${d.topic} ${d.type}`.toLowerCase();
//         if (!hay.includes(q)) return false;
//       }
//       return true;
//     });
//     list = [...list].sort((a, b) => {
//       if (sort === "az") return a.title.localeCompare(b.title);
//       if (sort === "downloads") return b.downloads - a.downloads;
//       const da = new Date(a.date).getTime();
//       const db = new Date(b.date).getTime();
//       return sort === "oldest" ? da - db : db - da;
//     });
//     return list;
//   }, [pool, query, year, topic, region, typeF, sort]);

//   const shown = filtered.slice(0, visible);
//   const hasMore = visible < filtered.length;

//   const activeChips = [];
//   if (query.trim()) activeChips.push({ k: "q", label: `"${query.trim()}"`, clear: () => setQuery("") });
//   if (year !== "All") activeChips.push({ k: "y", label: `Year: ${year}`, clear: () => setYear("All") });
//   if (topic !== "All") activeChips.push({ k: "t", label: topic, clear: () => setTopic("All") });
//   if (region !== "All") activeChips.push({ k: "r", label: region, clear: () => setRegion("All") });
//   if (typeF !== "All") activeChips.push({ k: "f", label: typeF, clear: () => setTypeF("All") });
//   const clearAll = () => {
//     setQuery("");
//     setYear("All");
//     setTopic("All");
//     setRegion("All");
//     setTypeF("All");
//   };

//   const trackRef = useRef(null);
//   const tabRefs = useRef({});
//   const [indicator, setIndicator] = useState({ left: 0, width: 0, ready: false });
//   const activeIndex = CATEGORIES.findIndex((c) => c.key === activeCat);
//   useLayoutEffect(() => {
//     const measure = () => {
//       const el = tabRefs.current[activeCat];
//       if (el) setIndicator({ left: el.offsetLeft, width: el.offsetWidth, ready: true });
//     };
//     measure();
//     const t = setTimeout(measure, 80);
//     window.addEventListener("resize", measure);
//     return () => {
//       clearTimeout(t);
//       window.removeEventListener("resize", measure);
//     };
//   }, [activeCat, activeIndex]);

//   const scrollToGrid = () => {
//     document.getElementById("repo-grid")?.scrollIntoView({ behavior: "smooth", block: "start" });
//   };

//   /* ------------------- TIPS modal: CLICK only (no hover) ----------------- */
//   const [tipsKey, setTipsKey] = useState(null); // key of the open modal (null = closed)

//   const openTips = (key) => setTipsKey(key);
//   const closeTipsModal = () => setTipsKey(null);

//   /* ------------------- Explore more -> PPTX preview modal ----------------- */
//   const [pptxOpen, setPptxOpen] = useState(false);

//   // agar user modal khula rehne par doosri category pe navigate kar de
//   useEffect(() => {
//     if (!isTipsPage) closeTipsModal();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isTipsPage]);

//   const tipsItem = useMemo(
//     () => TIPS_INFO.find((i) => i.key === tipsKey) || null,
//     [tipsKey]
//   );

//   const selectCls = "flex-1 min-w-[150px]";

//   return (
//     <>
//       <main className="overflow-hidden">
//         {/* ============================== HERO ============================== */}
//         <header id="top" className="relative overflow-hidden bg-[#FAF7F2]">
//           {/* backdrop decorations, same as AboutSection */}
//           <div className="hero-grid absolute inset-0" />
//           <div className="pointer-events-none absolute -top-32 left-1/2 h-[360px] w-[680px] -translate-x-1/2 rounded-full bg-[#DA2128]/10 blur-[130px]" />
//           <div className="pointer-events-none absolute -bottom-40 -right-24 h-[320px] w-[320px] rounded-full bg-[#DA2128]/[0.07] blur-[110px]" />

//           <Breadcrumb label={activeMeta.label} />

//           <div className="relative w-full max-w-[1280px] mx-auto px-6 lg:px-10  pt-28 sm:pt-32">
//             <Reveal>
//               <div className="max-w-3xl m-auto text-center">
//                 <div className="inline-flex items-center gap-2.5 rounded-full border border-[#B42318]/15 bg-white/70 backdrop-blur px-4 py-1.5">
//                   <span className="w-1.5 h-1.5 rounded-full bg-[#E8590C] animate-pulse" />
//                   <span className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-[#B42318]">
//                     {meta.eyebrow}
//                   </span>
//                 </div>

//                 <h1 className="mt-6 font-display text-gray-900 text-4xl sm:text-5xl md:text-[56px] leading-[1.05] tracking-tight [text-wrap:balance]">
//                   {meta.title}
//                 </h1>

//                 <p className="mt-6 text-gray-600 max-w-2xl leading-relaxed text-[15px] md:text-[16.5px]">
//                   {meta.sub}
//                 </p>
//               </div>
//             </Reveal>
//           </div>

//           {/* bottom shimmer line, same as AboutSection */}
//           <div className="shimmer-line h-px w-full" />
//         </header>

//         {/* ====================== FILTER + TABS + GRID ====================== */}
//         <section id="repo-grid" className="scroll-mt-24 py-16 md:py-20 bg-[#FAF7F2] relative">
//           <div className="absolute inset-0 pointer-events-none">
//             <div className="absolute -top-20 right-0 w-80 h-80 rounded-full bg-orange-500/5 blur-3xl" />
//             <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-red-700/5 blur-3xl" />
//           </div>

//           <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">

//             {/* ---- category tabs ---- */}
//             <Reveal>
//               <div className="flex justify-center">
//                 <div
//                   ref={trackRef}
//                   className="relative inline-flex items-stretch gap-1 max-w-full overflow-x-auto no-scrollbar rounded-t-2xl bg-white/50 ring-1 ring-orange-200/30 px-2" style={{display: "none"}}
//                 >
//                   {CATEGORIES.map((c) => {
//                     const Icon = c.icon;
//                     const active = c.key === activeCat;
//                     return (
//                       <button
//                         key={c.key}
//                         ref={(el) => (tabRefs.current[c.key] = el)}
//                         onClick={() => {
//                           setActiveCat(c.key);
//                           if (c.key !== categoryKey) {
//                             navigate(c.key);
//                           }
//                         }}
//                         className={`relative shrink-0 inline-flex items-center justify-center gap-2 rounded-t-lg px-4 md:px-5 py-3 text-[13.5px] font-semibold whitespace-nowrap leading-none transition-colors duration-200 ${
//                           active ? "text-red-700" : "text-gray-500 hover:text-red-700"
//                         }`}
//                       >
//                         <Icon
//                           className={`w-4 h-4 shrink-0 transition-colors ${
//                             active ? "text-orange-600" : "text-gray-400"
//                           }`}
//                         />
//                         <span>{c.label}</span>
//                       </button>
//                     );
//                   })}
//                   <span
//                     className="absolute bottom-0 h-[2.5px] rounded-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-300 ease-out"
//                     style={{
//                       left: indicator.left,
//                       width: indicator.width,
//                       opacity: indicator.ready ? 1 : 0,
//                     }}
//                   />
//                   <span className="absolute bottom-0 inset-x-2 h-px bg-orange-200/30" />
//                 </div>
//               </div>
//             </Reveal>

//             {/* ========== TIPS BUTTONS  —  SEARCH/FILTER DIV KE UPAR ========== *
//              *  Sirf TIPS page pe (categoryKey="tips"). 4 buttons:
//              *  About TIPS · What TIPS Does · How TIPS Supports Investors
//              *  + Explore more (PPTX).  Sab CLICK pe kaam karte hain.          */}
//             {isTipsPage && (
//               <Reveal delay={60}>
//                 <div className="mt-7 flex flex-wrap items-center gap-3 rounded-2xl bg-white/60 px-4 py-3 ring-1 ring-orange-200/30 backdrop-blur-sm md:px-5">
//                   <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-gray-400">
//                     TIPS at a glance
//                   </span>

//                   <div className="ml-auto flex flex-wrap items-center gap-3">
//                     <TipsQuickNav
//                       items={TIPS_NAV}
//                       activeKey={tipsKey}
//                       onSelect={openTips}
//                     />
//                     <ExploreMoreButton onClick={() => setPptxOpen(true)} />
//                   </div>
//                 </div>
//               </Reveal>
//             )}

//             {/* ---- filter bar ---- */}
//             <Reveal delay={80}>
//               <div
//                 className={`bg-white rounded-2xl ring-1 ring-orange-200/30 shadow-sm overflow-hidden ${
//                   isTipsPage ? "mt-3" : "mt-6"
//                 }`}
//               >
//                 <div className="flex items-center gap-3 flex-wrap p-4 md:p-5">
//                   <button
//                     onClick={() => setFiltersOpen((v) => !v)}
//                     className={`inline-flex items-center gap-2 rounded-xl px-3.5 h-10 text-[13px] font-semibold transition-colors ${
//                       filtersOpen
//                         ? "bg-red-700 text-white shadow-sm shadow-red-700/30"
//                         : "bg-[#FAF7F2] text-gray-700 ring-1 ring-orange-200/30 hover:ring-orange-400/60"
//                     }`}
//                   >
//                     <IconSliders className="w-4 h-4" />
//                     Filters
//                     {activeChips.length > 0 && (
//                       <span
//                         className={`min-w-[18px] h-[18px] px-1 rounded-full grid place-items-center text-[10px] font-bold ${
//                           filtersOpen ? "bg-white/25 text-white" : "bg-red-700 text-white"
//                         }`}
//                       >
//                         {activeChips.length}
//                       </span>
//                     )}
//                   </button>

//                   <div className="text-[12.5px] text-gray-500">
//                     <span className="font-bold text-gray-800">{filtered.length}</span>{" "}
//                     of {pool.length} documents
//                   </div>

//                   {/* ---- right side: search + sort ---- */}
//                   <div className="ml-auto flex items-center gap-2">
//                     <HoverSearch
//                       query={query}
//                       setQuery={setQuery}
//                       activeCat={activeCat}
//                       onSubmit={scrollToGrid}
//                     />

//                     <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 hidden sm:inline">Sort</span>
//                     <div className="relative">
//                       <select
//                         value={sort}
//                         onChange={(e) => setSort(e.target.value)}
//                         className="appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 outline-none text-[13px] font-semibold text-gray-700 pl-3 pr-9 py-2.5 cursor-pointer transition"
//                       >
//                         <option value="latest">Latest first</option>
//                         <option value="oldest">Oldest first</option>
//                         <option value="downloads">Most downloaded</option>
//                         <option value="az">Title A–Z</option>
//                       </select>
//                       <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
//                     </div>
//                   </div>
//                 </div>

//                 {/* collapsible filters */}
//                 <div
//                   className={`grid transition-all duration-300 ease-out ${
//                     filtersOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
//                   }`}
//                 >
//                   <div className="overflow-hidden">
//                     <div className="px-4 md:px-5 pb-4 md:pb-5 border-t border-orange-200/30 pt-4 space-y-4">
//                       <div className="flex flex-wrap gap-3">
//                         <div className={selectCls}>
//                           <Select label="Year" value={year} onChange={setYear} options={opts.years.map(String)} allLabel="All years" />
//                         </div>
//                         <div className={selectCls}>
//                           <Select label="Topic" value={topic} onChange={setTopic} options={opts.topics} />
//                         </div>
//                         <div className={selectCls}>
//                           <Select label="Region" value={region} onChange={setRegion} options={opts.regions} />
//                         </div>
//                       </div>

//                       <div className="flex items-center gap-2 flex-wrap">
//                         <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Format</span>
//                         {["All", ...opts.types].map((t) => {
//                           const active = typeF === t;
//                           return (
//                             <button
//                               key={t}
//                               onClick={() => setTypeF(t)}
//                               className={`rounded-full px-3 py-1 text-[12px] font-semibold ring-1 transition-all duration-200 ${
//                                 active
//                                   ? "bg-red-700 text-white ring-red-700 shadow-sm shadow-red-700/30 scale-[1.03]"
//                                   : "bg-white text-gray-600 ring-orange-200/30 hover:ring-orange-400/60 hover:text-red-700"
//                               }`}
//                             >
//                               {t === "All" ? "All formats" : t}
//                             </button>
//                           );
//                         })}
//                       </div>

//                       {activeChips.length > 0 && (
//                         <div className="flex items-center gap-2 flex-wrap pt-1">
//                           <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Active</span>
//                           {activeChips.map((c) => (
//                             <button
//                               key={c.k}
//                               onClick={c.clear}
//                               className="inline-flex items-center gap-1.5 rounded-full bg-orange-100 text-orange-800 ring-1 ring-orange-200/50 pl-3 pr-2 py-1 text-[12px] font-semibold hover:bg-orange-200/50 transition-colors"
//                             >
//                               {c.label}
//                               <span className="w-4 h-4 rounded-full grid place-items-center bg-orange-200/50 hover:bg-orange-600 hover:text-white transition-colors">
//                                 <IconClose className="w-2.5 h-2.5" stroke={3} />
//                               </span>
//                             </button>
//                           ))}
//                           <button
//                             onClick={clearAll}
//                             className="text-[12px] font-semibold text-red-700 hover:underline underline-offset-2 ml-1"
//                           >
//                             Clear all
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </Reveal>

//             {/* ---- results header ---- */}
//             <div className="mt-8 flex items-center justify-between gap-4">
//               <div className="flex items-center gap-3">
//                 <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-red-700 to-orange-600 text-white grid place-items-center ring-1 ring-white/20">
//                   <CatIcon className="w-[18px] h-[18px]" />
//                 </span>
//                 <div>
//                   <div className="font-display text-[15px] font-bold text-gray-900">
//                     {activeMeta.label}
//                   </div>
//                   <div className="text-[12px] text-gray-500">{activeMeta.short}</div>
//                 </div>
//               </div>
//             </div>

//             {/* ---- grid ---- */}
//             {docsLoading ? (
//               <Reveal>
//                 <div className="mt-6 rounded-2xl bg-white ring-1 ring-orange-200/30 p-12 text-center">
//                   <div className="mx-auto w-10 h-10 rounded-full border-2 border-orange-200 border-t-red-700 animate-spin" />
//                   <p className="mt-4 text-sm text-gray-500">Loading documents…</p>
//                 </div>
//               </Reveal>
//             ) : docsError ? (
//               <Reveal>
//                 <div className="mt-6 rounded-2xl bg-white ring-1 ring-red-200/50 p-12 text-center">
//                   <p className="text-sm font-semibold text-red-700">Couldn't load documents.</p>
//                   <p className="mt-1 text-sm text-gray-500">{docsError}</p>
//                 </div>
//               </Reveal>
//             ) : filtered.length === 0 ? (
//               <Reveal>
//                 <div className="mt-6 rounded-2xl bg-white ring-1 ring-orange-200/30 p-12 text-center">
//                   <div className="mx-auto w-16 h-16 rounded-2xl bg-[#FAF7F2] ring-1 ring-orange-200/30 grid place-items-center text-orange-700">
//                     <IconSearch className="w-7 h-7" />
//                   </div>
//                   <h3 className="mt-5 font-display text-xl text-gray-900">No documents match your filters</h3>
//                   <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
//                     Try widening the year or region, clearing the format, or resetting your search.
//                   </p>
//                   <button
//                     onClick={clearAll}
//                     className="mt-6 inline-flex items-center gap-2 rounded-full bg-red-700 hover:bg-red-800 text-white text-sm font-semibold px-5 py-2.5 transition-colors"
//                   >
//                     <IconClose className="w-4 h-4" stroke={2.4} /> Clear all filters
//                   </button>
//                 </div>
//               </Reveal>
//             ) : (
//               <>
//                 <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
//                   {shown.map((doc, i) => (
//                     <DocCard key={doc.id} doc={doc} index={i} />
//                   ))}
//                 </div>

//                 {hasMore && (
//                   <div className="mt-10 flex justify-center">
//                     <button
//                       onClick={() => setVisible((v) => v + 6)}
//                       className="group inline-flex items-center gap-2.5 rounded-full bg-white ring-1 ring-orange-200/40 hover:ring-orange-500/70 text-gray-800 text-sm font-semibold px-7 py-3.5 shadow-sm hover:shadow-lg hover:shadow-orange-500/10 transition-all"
//                     >
//                       Load More Research Documents
//                       <span className="w-6 h-6 rounded-full grid place-items-center bg-red-700/10 text-red-700 transition-all duration-300 group-hover:bg-red-700 group-hover:text-white group-hover:rotate-180">
//                         <IconChevronDown className="w-3.5 h-3.5" stroke={2.6} />
//                       </span>
//                     </button>
//                   </div>
//                 )}

//                 {!hasMore && filtered.length > 6 && (
//                   <div className="mt-10 text-center text-[12.5px] text-gray-400">
//                     You've reached the end of the {activeMeta.label.toLowerCase()} stream.
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         </section>
//       </main>

//       {/* --------- TIPS modal: sirf TIPS page pe mount hota hai --------- */}
//       {isTipsPage && (
//         <>
//           <TipsInfoModal
//             item={tipsItem}
//             items={TIPS_NAV}
//             onClose={closeTipsModal}
//             onSelect={openTips}
//           />
//           <PptxModal
//             open={pptxOpen}
//             url={TIPS_PPTX_URL}
//             pdfUrl={TIPS_PDF_URL}
//             onClose={() => setPptxOpen(false)}
//           />
//         </>
//       )}
//     </>
//   );
// }








// new code 








import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  IconArrow,
  IconDoc,
  IconSearch,
  IconDownload,
  IconChevronDown,
  IconCalendar,
  IconUser,
  IconClose,
  IconSliders,
  IconLayers,
  IconClock,
  IconChart,
} from "./icons";
import {
  CATEGORIES,
  CATEGORY_MAP,
  TYPE_STYLES,
  formatDownloads,
  formatSize,
} from "../data/Research";
import {
  fetchResearchDocuments,
  optionsFor,
  openDoc,
  downloadDoc,
} from "./Researchapi";

/* =========================================================================== *
 *  TIPS  —  buttons + modal
 *  Sab kuch SIRF TIPS page pe render hota hai, i.e. jab activeCat === "tips"
 *  <Route path="/global-research/tips"
 *         element={<ResearchRepositoryPage categoryKey="tips" />} />
 *  Kisi doosri category / route pe ye buttons ya modal nahi aayenge.
 * =========================================================================== */

/* ---- PDF: apni file ka path yahan set karo -------------------------------
 * 1) public folder me rakho  -> "/TIPS-Overview.pdf"
 * 2) ya import karke is file me use karo:
 *      import tipsPdf from "../assets/TIPS-Overview.pdf";
 *      const TIPS_PDF_URL = tipsPdf;
 *
 * NOTE: "Explore more" is CLICK-only aur seedha ek naye TAB me PDF kholta
 * hai — browser ka native PDF viewer use hoga. Koi Office viewer / preview
 * modal / pre-fetch check nahi hai.
 * ------------------------------------------------------------------------ */
const TIPS_PDF_URL = "https://assocham.org/assocham_backend/api/TIPS_Opeinig.pdf";

/* PDF ko naye tab me kholta hai — direct open, browser native handling */
function openPdf(url) {
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
}

/* File download trigger (popup block ho to bhi kaam karta hai) */
function downloadFile(url, filename = "TIPS_Opeinig.pdf") {
  if (!url) return;
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/* ------------------------- TIPS content (data) ---------------------------- */
const TIPS_INFO = [
  {
    key: "about-tips",
    index: "01",
    label: "About TIPS",
    eyebrow: "Trade & Investment Promotion Services",
    title: "About TIPS",
    subtitle:
      "A flagship initiative of the ASSOCHAM Global Research & Strategy Centre (AGRSC)",
    paragraphs: [
      "Trade & Investment Promotion Services (TIPS) is a flagship initiative of the ASSOCHAM Global Research & Strategy Centre (AGRSC). It is a one-stop platform for domestic and international investors and exporters, combining the Centre's research depth and policy insight with on-ground facilitation, so that businesses have a single point of contact for trading with or investing in India.",
      "TIPS supports India's vision of Viksit Bharat @ 2047, aligned with Make in India, Ease of Doing Business and Atmanirbhar Bharat. It aims to facilitate annual FDI of US$ 100 billion into India and to support US$ 1,000 billion in annual merchandise exports and US$ 1,000 billion in annual services exports by 2030.",
    ],
  },
  {
    key: "what-tips-does",
    index: "02",
    label: "What TIPS Does",
    eyebrow: "Facilitator · Advisor · Convenor",
    title: "What TIPS Does",
    subtitle:
      "A multi-dimensional role across India's trade and investment ecosystem",
    paragraphs: [
      "TIPS plays a multi-dimensional role as facilitator, advisor and convenor for India's trade and investment ecosystem.",
    ],
    items: [
      {
        title: "One-Stop Facilitation Platform",
        text: "A single platform for trade, investment and business collaboration in India, reducing the need to navigate multiple agencies independently.",
      },
      {
        title: "Investment & Regulatory Guidance",
        text: "Investment facilitation, policy guidance, market intelligence and regulatory support for domestic and international investors.",
      },
      {
        title: "Trade Promotion",
        text: "Connects businesses with new markets, export opportunities and strategic partners to expand their global and domestic footprint.",
      },
      {
        title: "Stakeholder Engagement",
        text: "Facilitates engagement between industry, government, financial institutions and global stakeholders on investment and trade challenges.",
      },
      {
        title: "Sectoral & Regional Development",
        text: "Identifies high-potential investment opportunities across sectors and states to encourage sustainable economic growth.",
      },
      {
        title: "Policy Intelligence",
        text: "Tracks and disseminates updates on policy reforms and international trade developments for industry and investors.",
      },
    ],
  },
  {
    key: "how-tips-supports-investors",
    index: "03",
    label: "How TIPS Supports Investors",
    eyebrow: "Structured support · On-ground engagement",
    title: "How TIPS Supports Investors",
    subtitle:
      "A one-stop reference point for domestic and international investors exploring opportunities in India",
    paragraphs: [
      "TIPS is a one-stop reference point for domestic and international investors exploring opportunities in India, offering structured support and active on-ground engagement. TIPS supports investors by:",
    ],
    bullets: [
      "Providing sector-specific and state-specific market intelligence to identify suitable investment opportunities.",
      "Guiding investors on investment procedures, regulatory approvals, policies and compliance requirements at Central and State levels.",
      "Facilitating interactions with Central and State Government departments, regulatory authorities and industry stakeholders.",
      "Assisting in identifying suitable project locations, business partners and joint venture opportunities.",
      "Undertaking specialised advisory assignments, including market research, financial analysis, due diligence and support for JVs, mergers and acquisitions.",
      "Providing regular updates on economic developments, sectoral trends, policy reforms, FDI regulations and taxation, with continuous handholding throughout the investment journey.",
    ],
  },
];

const TIPS_NAV = TIPS_INFO.map(({ key, label, index }) => ({ key, label, index }));

/* ----------------------------- tiny utilities ---------------------------- */
function useInView(opts = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ob = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setInView(true);
          ob.disconnect();
        }
      },
      { threshold: 0.12, ...opts }
    );
    ob.observe(el);
    return () => ob.disconnect();
  }, []);
  return [ref, inView];
}

function Reveal({ children, delay = 0, className = "" }) {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}

function CountUp({ value, format = (n) => String(n), duration = 1100 }) {
  const [ref, inView] = useInView();
  const [display, setDisplay] = useState(0);
  const fromRef = useRef(0);
  useEffect(() => {
    if (!inView) return;
    const from = fromRef.current;
    const to = value;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      const cur = Math.round(from + (to - from) * eased);
      setDisplay(cur);
      if (t < 1) raf = requestAnimationFrame(tick);
      else fromRef.current = to;
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration]);
  return <span ref={ref}>{format(display)}</span>;
}

/* Small triangle arrow — same mark used in the Leadership modal/buttons */
function TipsArrow({ className = "h-2.5 w-2" }) {
  return (
    <svg viewBox="0 0 8 12" className={`${className} flex-shrink-0 fill-[#f47b20]`} aria-hidden="true">
      <polygon points="0,0 8,6 0,12" />
    </svg>
  );
}

/* PDF file icon */
function IconPdf({ className = "h-4 w-4" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.9}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 4.5h18v12H3z" />
      <path d="M12 16.5V21" />
      <path d="M8.5 21h7" />
      <path d="M7.5 13.5V7.8h2.1a1.9 1.9 0 0 1 0 3.8H7.5" />
      <path d="M13.2 7.8v5.7h1.6a1.4 1.4 0 0 0 1.4-1.4V9.2a1.4 1.4 0 0 0-1.4-1.4h-1.6z" />
    </svg>
  );
}

/* =========================================================================== *
 *  TIPS INFO MODAL  —  Leadership BioModal jaisa hi look / behaviour
 *  (cream panel, 4px grey frame, orange accents, numbered index, X bar,
 *   scrollable body, Escape + backdrop close, scroll lock)
 * =========================================================================== */
function TipsInfoModal({ item, items = [], onClose, onSelect }) {
  useEffect(() => {
    if (!item) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [item, onClose]);

  if (!item) return null;

  const activeIndex = items.findIndex((i) => i.key === item.key);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#0a2c5c]/70 px-4 py-8 backdrop-blur-sm"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="tips-modal-title"
    >
      <div
        className="relative flex max-h-[85vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl border-4 border-[#dddfe1] bg-[#f3ece2] shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ---------------- Header (index + title + X bar) ---------------- */}
        <div className="flex items-start justify-between gap-4 border-b-2 border-[#f47b20]/30 bg-[#f3ece2] px-6 py-5 sm:px-8">
          <div className="flex items-start gap-4">
            <span className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full border-2 border-[#f47b20] bg-white text-lg font-extrabold text-[#f47b20]">
              {item.index}
            </span>
            <div className="min-w-0">
              <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#0a2c5c]/60">
                {item.eyebrow}
              </p>
              <h3
                id="tips-modal-title"
                className="mt-1 text-lg font-extrabold leading-tight text-[#0a2c5c] sm:text-xl"
              >
                {item.title}
              </h3>
              {item.subtitle && (
                <p className="mt-1 text-sm font-semibold leading-snug text-[#f47b20]">
                  {item.subtitle}
                </p>
              )}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close TIPS information"
            className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border-2 border-[#f47b20] text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.5}
              strokeLinecap="round"
            >
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        {/* ------------------------------ Body ----------------------------- */}
        <div className="space-y-5 overflow-y-auto px-6 py-6 text-sm leading-relaxed text-[#0a2c5c]/90 sm:px-8 sm:text-base">
          {item.paragraphs?.map((p, i) => (
            <p key={`p-${i}`}>{p}</p>
          ))}

          {item.stats?.length > 0 && (
            <div className="grid gap-3 sm:grid-cols-3">
              {item.stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-xl border-2 border-[#dddfe1] bg-white px-4 py-3"
                >
                  <p className="text-[15px] font-extrabold leading-tight text-[#f47b20]">
                    {s.value}
                  </p>
                  <p className="mt-1 text-[11px] font-bold uppercase tracking-wide text-[#0a2c5c]/70">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>
          )}

          {item.pointers?.length > 0 && (
            <ul className="space-y-2.5">
              {item.pointers.map((p, i) => (
                <li key={`pt-${i}`} className="flex items-start gap-3">
                  <span className="mt-[7px] flex h-4 w-4 flex-shrink-0 items-center justify-center">
                    <TipsArrow className="h-2.5 w-2" />
                  </span>
                  <span className="text-[13.5px] font-semibold leading-relaxed text-[#0a2c5c] sm:text-[14.5px]">
                    {p}
                  </span>
                </li>
              ))}
            </ul>
          )}

          {item.items?.length > 0 && (
            <ol className="space-y-3">
              {item.items.map((it, i) => (
                <li
                  key={it.title}
                  className="flex gap-4 rounded-xl border-2 border-[#dddfe1] bg-white p-4"
                >
                  <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#EE8202] text-[12px] font-extrabold text-white">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="min-w-0">
                    <p className="text-[14.5px] font-bold leading-snug text-[#0a2c5c]">
                      {it.title}
                    </p>
                    <p className="mt-1 text-[13.5px] leading-relaxed text-[#0a2c5c]/85">
                      {it.text}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          )}

          {item.bullets?.length > 0 && (
            <ul className="space-y-2.5">
              {item.bullets.map((b, i) => (
                <li key={`b-${i}`} className="flex items-start gap-3">
                  <span className="mt-[2px] flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#f47b20]/15 text-[11px] font-extrabold text-[#f47b20]">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-[13.5px] leading-relaxed text-[#0a2c5c]/90 sm:text-[14.5px]">
                    {b}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* --------------- Footer: section index switcher + close ------------ */}
        <div className="flex flex-wrap items-center justify-between gap-3 border-t-2 border-[#f47b20]/30 bg-[#f3ece2] px-6 py-4 sm:px-8">
          <div className="flex items-center gap-2">
            <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#0a2c5c]/50">
              Section
            </span>
            {items.map((it) => {
              const active = it.key === item.key;
              return (
                <button
                  key={it.key}
                  type="button"
                  onClick={() => onSelect?.(it.key)}
                  aria-label={it.label}
                  aria-current={active ? "true" : undefined}
                  className={`h-8 w-8 rounded-full border-2 text-[12px] font-extrabold transition-colors ${
                    active
                      ? "border-[#f47b20] bg-[#f47b20] text-white"
                      : "border-[#dddfe1] bg-white text-[#0a2c5c] hover:border-[#f47b20] hover:text-[#f47b20]"
                  }`}
                >
                  {it.index}
                </button>
              );
            })}
            {activeIndex >= 0 && (
              <span className="ml-1 text-[12px] font-bold text-[#0a2c5c]/50">
                {activeIndex + 1} / {items.length}
              </span>
            )}
          </div>

          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-transparent px-5 py-2.5 text-sm font-bold text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
          >
            <span>Close</span>
            <TipsArrow />
          </button>
        </div>
      </div>
    </div>
  );
}

/* ------------- TIPS info button — CLICK-ONLY trigger -----------------------
 * Same gradient-pill visual language as "Explore more".
 * Modal SIRF CLICK par khulta hai — hover par sirf style change hota hai
 * (gradient + arrow slide), modal NAHI khulta. Keyboard se bhi kaam karta
 * hai: Tab se button focus karo, Enter/Space dabao (native button behaviour).
 * Touch/mobile par tap = click, wahan bhi theek chalega.
 * Closing modal ke andar se hoti hai: X / Close button / Escape / backdrop. */
function TipsInfoButton({ item, active, onOpen }) {
  return (
    <button
      type="button"
      onClick={() => onOpen(item.key)}
      aria-haspopup="dialog"
      aria-expanded={active ? "true" : "false"}
      className={`group/tip inline-flex h-10 flex-shrink-0 items-center gap-2.5 rounded-full pl-3.5 pr-3 text-[13px] font-semibold whitespace-nowrap transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/70 ${
        active
          ? "bg-gradient-to-r from-red-700 to-orange-600 text-white shadow-sm shadow-red-700/30"
          : "bg-[#FAF7F2] text-gray-700 ring-1 ring-orange-200/30 hover:from-red-700 hover:to-orange-600 hover:bg-gradient-to-r hover:text-white hover:shadow-sm hover:shadow-red-700/30"
      }`}
    >
      <span
        className={`grid h-6 w-6 flex-shrink-0 place-items-center rounded-full text-[11px] font-extrabold transition-colors ${
          active ? "bg-white/20 text-white" : "bg-white text-red-700 ring-1 ring-orange-200/40 group-hover/tip:bg-white/20 group-hover/tip:text-white group-hover/tip:ring-0"
        }`}
      >
        {item.index}
      </span>
      <span>{item.label}</span>
      <span
        className={`grid h-6 w-6 flex-shrink-0 place-items-center rounded-full transition-all duration-300 ${
          active ? "bg-white/20 translate-x-0.5" : "bg-white/60 group-hover/tip:bg-white/20 group-hover/tip:translate-x-0.5"
        }`}
      >
        <TipsArrow className={`h-2.5 w-2 ${active ? "fill-white" : "fill-[#f47b20] group-hover/tip:fill-white"}`} />
      </span>
    </button>
  );
}

/* -------------------------- Explore more (PDF) -------------------------- */
function ExploreMoreButton({ onClick, label = "Explore more" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`${label} — open TIPS presentation (PDF) in a new tab`}
      className="group/explore inline-flex h-10 items-center gap-2.5 rounded-full bg-gradient-to-r from-red-700 to-orange-600 pl-4 pr-3 text-[13px] font-semibold text-white shadow-sm shadow-red-700/30 transition-all duration-300 hover:from-orange-600 hover:to-amber-500 hover:shadow-lg hover:shadow-red-700/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/70"
    >
      <IconDoc className="h-[18px] w-[18px]" />
      <span>{label}</span>
      <span className="grid h-6 w-6 place-items-center rounded-full bg-white/20 transition-transform duration-300 group-hover/explore:translate-x-0.5">
        <TipsArrow className="h-2.5 w-2 fill-white" />
      </span>
    </button>
  );
}

/* ------------------------------- document card --------------------------- */
function DocCard({ doc, index }) {
  const typeCls = TYPE_STYLES[doc.type] || TYPE_STYLES.REPORT;
  return (
    <Reveal delay={Math.min(index, 8) * 70} className="h-full">
      <article className="group relative flex flex-col h-full bg-white rounded-2xl p-6 ring-1 ring-orange-200/50 shadow-sm hover:shadow-2xl hover:shadow-red-900/10 transition-all duration-300 hover:-translate-y-1.5 overflow-hidden">
        <span className="absolute top-0 left-0 h-[3px] w-10 rounded-r-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-500 group-hover:w-full" />
        <span className="pointer-events-none absolute -top-12 -right-12 w-28 h-28 rounded-full bg-orange-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        <div className="flex items-start gap-4">
          <div className="relative w-12 h-12 shrink-0 rounded-xl bg-gradient-to-br from-[#FAF7F2] to-white ring-1 ring-orange-200/30 grid place-items-center text-red-700 transition-all duration-300 group-hover:from-red-700 group-hover:to-orange-600 group-hover:text-white group-hover:scale-105 group-hover:-rotate-3">
            <IconDoc className="w-[22px] h-[22px]" />
            <span className="absolute -bottom-1.5 -right-1.5 text-[8px] font-extrabold tracking-wider bg-red-700 text-white rounded px-1 py-px ring-2 ring-white group-hover:bg-white group-hover:text-red-700 transition-colors">
              PDF
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="font-display text-[15.5px] leading-snug text-gray-900 line-clamp-2 group-hover:text-red-700 transition-colors duration-200">
              {doc.title}
            </h3>
            <div className="mt-2 flex items-center gap-2 flex-wrap">
              <span
                className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ring-1 ${typeCls}`}
              >
                {doc.type}
              </span>
              <span className="text-[10px] font-semibold text-gray-400 inline-flex items-center gap-1">
                <IconLayers className="w-3 h-3" /> {doc.pages} pp
              </span>
              <span className="text-[10px] font-semibold text-gray-400">
                · {formatSize(doc.sizeKB)}
              </span>
            </div>
          </div>
        </div>

        <p className="mt-4 text-[13px] leading-relaxed text-gray-600 line-clamp-3">
          {doc.abstract}
        </p>

        <div className="mt-5 grid grid-cols-2 gap-3 border-t border-dashed border-orange-200/30 pt-4">
          <div className="min-w-0">
            <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
              Publication Date
            </div>
            <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5">
              <IconCalendar className="w-3.5 h-3.5 text-orange-700" />
              {doc.date}
            </div>
          </div>
          <div className="min-w-0">
            <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
              Author
            </div>
            <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5 min-w-0">
              <IconUser className="w-3.5 h-3.5 text-orange-700 shrink-0" />
              <span className="truncate">{doc.author}</span>
            </div>
          </div>
        </div>

        {/* <div className="mt-3 flex items-center gap-1.5 text-[11px] text-gray-400">
          <IconDownload className="w-3.5 h-3.5" />
          <span className="font-semibold text-gray-500">
            {formatDownloads(doc.downloads)}
          </span>
          <span>downloads</span>
          <span className="mx-1 text-gray-300">·</span>
          <span>{doc.region}</span>
        </div> */}

        <div className="mt-auto pt-5 flex items-stretch gap-2">
          <button
            onClick={() => openDoc(doc)}
            className="group/btn flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-red-700 to-red-800 text-white text-[13px] font-semibold py-2.5 shadow-sm hover:from-orange-600 hover:to-red-700 transition-all duration-300 hover:shadow-lg hover:shadow-red-700/30"
          >
            <IconDoc className="w-4 h-4" />
            View Document
          </button>
          {/* <button
            onClick={() => downloadDoc(doc)}
            aria-label={`Download ${doc.title} (PDF)`}
            className="w-11 shrink-0 grid place-items-center rounded-lg bg-[#FAF7F2] text-red-700 ring-1 ring-orange-200/30 hover:bg-amber-500 hover:text-white hover:ring-amber-500 transition-all duration-300"
          >
            <IconDownload className="w-[18px] h-[18px] transition-transform duration-300 group-hover:translate-y-0.5" />
          </button> */}
        </div>
      </article>
    </Reveal>
  );
}

/* ----------------------------- styled select ----------------------------- */
function Select({ label, value, onChange, options, allLabel = "All" }) {
  return (
    <label className="relative block">
      <span className="sr-only">{label}</span>
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[11px] font-bold uppercase tracking-wider text-gray-400 pointer-events-none">
        {label}
      </span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 focus:bg-white outline-none text-[13px] font-semibold text-gray-700 pl-[68px] pr-9 py-2.5 cursor-pointer transition"
      >
        <option value="All">{allLabel}</option>
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
      <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
    </label>
  );
}

/* ------------------------- hover-expanding search ------------------------- */
function HoverSearch({ query, setQuery, activeCat, onSubmit }) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.();
      }}
      className="group/search relative flex items-center gap-2 rounded-full bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus-within:ring-2 focus-within:ring-orange-500/70 hover:bg-white focus-within:bg-white transition-all duration-300 ease-out h-10 w-10 hover:w-64 focus-within:w-64 pl-2.5 pr-1 overflow-hidden shrink-0"
    >
      <IconSearch className="w-4 h-4 text-orange-700 shrink-0" />
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={`Search ${activeCat === "all" ? "repository" : "stream"}…`}
        className="bg-transparent outline-none text-gray-900 placeholder:text-gray-400 text-[13px] w-full min-w-0 opacity-0 group-hover/search:opacity-100 group-focus-within/search:opacity-100 transition-opacity duration-200 delay-100"
      />
      {query && (
        <button
          type="button"
          onClick={() => setQuery("")}
          aria-label="Clear search"
          className="w-6 h-6 shrink-0 rounded-full grid place-items-center text-gray-400 hover:bg-gray-100 hover:text-red-700 opacity-0 group-hover/search:opacity-100 group-focus-within/search:opacity-100 transition-opacity duration-200"
        >
          <IconClose className="w-3.5 h-3.5" stroke={2.4} />
        </button>
      )}
    </form>
  );
}

/* ----------------------------- breadcrumb ----------------------------- */
function Breadcrumb({ label }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
    >
      <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
        <li>
          <a
            href="/"
            className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </a>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li>
          <span className="transition-colors duration-300 hover:text-[#DA2128]">
            Global Research
          </span>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">
          {label}
        </li>
      </ol>
    </nav>
  );
}

/* =========================================================================== *
 *  REPOSITORY PAGE
 * =========================================================================== */
export default function ResearchRepository({
  categoryKey,
  navigate,
  query,
  setQuery,
}) {
  const meta = CATEGORY_MAP[categoryKey] || CATEGORY_MAP.all;
  const CatIcon = meta.icon;

  const [activeCat, setActiveCat] = useState(categoryKey);
  const [year, setYear] = useState("All");
  const [topic, setTopic] = useState("All");
  const [region, setRegion] = useState("All");
  const [typeF, setTypeF] = useState("All");
  const [sort, setSort] = useState("latest");
  const [visible, setVisible] = useState(6);
  const [filtersOpen, setFiltersOpen] = useState(true);

  const [DOCUMENTS, setDocuments] = useState([]);
  const [docsLoading, setDocsLoading] = useState(true);
  const [docsError, setDocsError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setDocsLoading(true);
    setDocsError(null);
    fetchResearchDocuments()
      .then((docs) => {
        if (!cancelled) setDocuments(docs);
      })
      .catch((err) => {
        if (!cancelled) setDocsError(err.message || "Could not load documents.");
      })
      .finally(() => {
        if (!cancelled) setDocsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const opts = useMemo(() => optionsFor(DOCUMENTS, activeCat), [DOCUMENTS, activeCat]);

  // Keep activeCat in sync with the categoryKey prop — this component doesn't
  // remount on route changes (React Router reuses it), so if the user lands
  // here via a dropdown/menu link that only changes categoryKey, activeCat
  // (and therefore the breadcrumb) would otherwise stay stuck on the old value.
  useEffect(() => {
    setActiveCat(categoryKey);
  }, [categoryKey]);

  useEffect(() => {
    setYear("All");
    setTopic("All");
    setRegion("All");
    setTypeF("All");
    setVisible(6);
  }, [activeCat]);

  // const activeMeta = CATEGORY_MAP[activeCat];
  const activeMeta = CATEGORY_MAP[activeCat] || CATEGORY_MAP.all;

  /* ---------------- TIPS gate: sirf TIPS page / route pe ---------------- */
  const isTipsPage = activeCat === "tips";

  const pool = useMemo(
    () =>
      activeCat === "all"
        ? DOCUMENTS
        : DOCUMENTS.filter((d) => d.category === activeCat),
    [activeCat, DOCUMENTS]
  );
  const maxYear = useMemo(
    () => (pool.length ? Math.max(...pool.map((d) => d.year)) : new Date().getFullYear()),
    [pool]
  );

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    let list = pool.filter((d) => {
      if (year !== "All" && String(d.year) !== String(year)) return false;
      if (topic !== "All" && d.topic !== topic) return false;
      if (region !== "All" && d.region !== region) return false;
      if (typeF !== "All" && d.type !== typeF) return false;
      if (q) {
        const hay = `${d.title} ${d.abstract} ${d.author} ${d.topic} ${d.type}`.toLowerCase();
        if (!hay.includes(q)) return false;
      }
      return true;
    });
    list = [...list].sort((a, b) => {
      if (sort === "az") return a.title.localeCompare(b.title);
      if (sort === "downloads") return b.downloads - a.downloads;
      const da = new Date(a.date).getTime();
      const db = new Date(b.date).getTime();
      return sort === "oldest" ? da - db : db - da;
    });
    return list;
  }, [pool, query, year, topic, region, typeF, sort]);

  const shown = filtered.slice(0, visible);
  const hasMore = visible < filtered.length;

  const activeChips = [];
  if (query.trim()) activeChips.push({ k: "q", label: `"${query.trim()}"`, clear: () => setQuery("") });
  if (year !== "All") activeChips.push({ k: "y", label: `Year: ${year}`, clear: () => setYear("All") });
  if (topic !== "All") activeChips.push({ k: "t", label: topic, clear: () => setTopic("All") });
  if (region !== "All") activeChips.push({ k: "r", label: region, clear: () => setRegion("All") });
  if (typeF !== "All") activeChips.push({ k: "f", label: typeF, clear: () => setTypeF("All") });
  const clearAll = () => {
    setQuery("");
    setYear("All");
    setTopic("All");
    setRegion("All");
    setTypeF("All");
  };

  const trackRef = useRef(null);
  const tabRefs = useRef({});
  const [indicator, setIndicator] = useState({ left: 0, width: 0, ready: false });
  const activeIndex = CATEGORIES.findIndex((c) => c.key === activeCat);
  useLayoutEffect(() => {
    const measure = () => {
      const el = tabRefs.current[activeCat];
      if (el) setIndicator({ left: el.offsetLeft, width: el.offsetWidth, ready: true });
    };
    measure();
    const t = setTimeout(measure, 80);
    window.addEventListener("resize", measure);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", measure);
    };
  }, [activeCat, activeIndex]);

  const scrollToGrid = () => {
    document.getElementById("repo-grid")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  /* ------------------- TIPS modal: SIRF CLICK se khulta hai --------------
   * tipsKey = key of the item whose modal is open (null = closed).
   * TipsInfoButton ke onClick se set hota hai — hover/focus se NAHI.
   * Closing modal ke andar se hoti hai: X / Close button / Escape /
   * backdrop-click.                                                        */
  const [tipsKey, setTipsKey] = useState(null);

  const openTips = (key) => setTipsKey(key);
  const closeTipsModal = () => setTipsKey(null);

  // agar user modal khula rehne par doosri category pe navigate kar de
  useEffect(() => {
    if (!isTipsPage) closeTipsModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTipsPage]);

  const tipsItem = useMemo(
    () => TIPS_INFO.find((i) => i.key === tipsKey) || null,
    [tipsKey]
  );

  const selectCls = "flex-1 min-w-[150px]";

  return (
    <>
      <main className="overflow-hidden">
        {/* ============================== HERO ============================== */}
        <header id="top" className="relative overflow-hidden bg-[#FAF7F2]">
          {/* backdrop decorations, same as AboutSection */}
          <div className="hero-grid absolute inset-0" />
          <div className="pointer-events-none absolute -top-32 left-1/2 h-[360px] w-[680px] -translate-x-1/2 rounded-full bg-[#DA2128]/10 blur-[130px]" />
          <div className="pointer-events-none absolute -bottom-40 -right-24 h-[320px] w-[320px] rounded-full bg-[#DA2128]/[0.07] blur-[110px]" />

          <Breadcrumb label={activeMeta.label} />

          <div className="relative w-full max-w-[1280px] mx-auto px-6 lg:px-10  pt-28 sm:pt-32">
            <Reveal>
              <div className="max-w-3xl m-auto text-center">
                <h1 className="mt-6 font-display text-gray-900 text-4xl sm:text-5xl md:text-[56px] leading-[1.05] tracking-tight [text-wrap:balance]">
                  {meta.title}
                </h1>
              </div>
            </Reveal>
          </div>

          {/* bottom shimmer line, same as AboutSection */}
          <div className="shimmer-line h-px w-full" />
        </header>

        {/* ====================== FILTER + TABS + GRID ====================== */}
        <section id="repo-grid" className="scroll-mt-24 py-16 md:py-20 bg-[#FAF7F2] relative">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-20 right-0 w-80 h-80 rounded-full bg-orange-500/5 blur-3xl" />
            <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-red-700/5 blur-3xl" />
          </div>

          <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">

            {/* ---- category tabs ---- */}
            <Reveal>
              <div className="flex justify-center">
                <div
                  ref={trackRef}
                  className="relative inline-flex items-stretch gap-1 max-w-full overflow-x-auto no-scrollbar rounded-t-2xl bg-white/50 ring-1 ring-orange-200/30 px-2" style={{display: "none"}}
                >
                  {CATEGORIES.map((c) => {
                    const Icon = c.icon;
                    const active = c.key === activeCat;
                    return (
                      <button
                        key={c.key}
                        ref={(el) => (tabRefs.current[c.key] = el)}
                        onClick={() => {
                          setActiveCat(c.key);
                          if (c.key !== categoryKey) {
                            navigate(c.key);
                          }
                        }}
                        className={`relative shrink-0 inline-flex items-center justify-center gap-2 rounded-t-lg px-4 md:px-5 py-3 text-[13.5px] font-semibold whitespace-nowrap leading-none transition-colors duration-200 ${
                          active ? "text-red-700" : "text-gray-500 hover:text-red-700"
                        }`}
                      >
                        <Icon
                          className={`w-4 h-4 shrink-0 transition-colors ${
                            active ? "text-orange-600" : "text-gray-400"
                          }`}
                        />
                        <span>{c.label}</span>
                      </button>
                    );
                  })}
                  <span
                    className="absolute bottom-0 h-[2.5px] rounded-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-300 ease-out"
                    style={{
                      left: indicator.left,
                      width: indicator.width,
                      opacity: indicator.ready ? 1 : 0,
                    }}
                  />
                  <span className="absolute bottom-0 inset-x-2 h-px bg-orange-200/30" />
                </div>
              </div>
            </Reveal>

            {isTipsPage && (
              <Reveal delay={60}>
                <div className="mt-7 flex flex-wrap items-center gap-3 rounded-2xl bg-white/60 px-4 py-3 ring-1 ring-orange-200/30 backdrop-blur-sm md:px-5">
                  <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-gray-400">
                    TIPS at a glance
                  </span>

                  <div className="flex flex-wrap items-center gap-2">
                    {TIPS_NAV.map((it) => (
                      <TipsInfoButton
                        key={it.key}
                        item={it}
                        active={it.key === tipsKey}
                        onOpen={openTips}
                      />
                    ))}
                  </div>

                  <div className="ml-auto flex flex-wrap items-center gap-2">
                    <ExploreMoreButton onClick={() => openPdf(TIPS_PDF_URL)} />
                    <button
                      type="button"
                      onClick={() => downloadFile(TIPS_PDF_URL)}
                      aria-label="Download TIPS presentation"
                      className="grid h-10 w-10 flex-shrink-0 place-items-center rounded-full bg-white text-red-700 ring-1 ring-orange-200/40 transition-all duration-300 hover:bg-[#FAF7F2] hover:ring-orange-400/70"
                    >
                      <IconDownload className="h-[18px] w-[18px]" />
                    </button>
                  </div>
                </div>
              </Reveal>
            )}

            {/* ---- filter bar ---- */}
            <Reveal delay={80}>
              <div
                className={`bg-white rounded-2xl ring-1 ring-orange-200/30 shadow-sm overflow-hidden ${
                  isTipsPage ? "mt-3" : "mt-6"
                }`}
              >
                <div className="flex items-center gap-3 flex-wrap p-4 md:p-5">
                  <button
                    onClick={() => setFiltersOpen((v) => !v)}
                    className={`inline-flex items-center gap-2 rounded-xl px-3.5 h-10 text-[13px] font-semibold transition-colors ${
                      filtersOpen
                        ? "bg-red-700 text-white shadow-sm shadow-red-700/30"
                        : "bg-[#FAF7F2] text-gray-700 ring-1 ring-orange-200/30 hover:ring-orange-400/60"
                    }`}
                  >
                    <IconSliders className="w-4 h-4" />
                    Filters
                    {activeChips.length > 0 && (
                      <span
                        className={`min-w-[18px] h-[18px] px-1 rounded-full grid place-items-center text-[10px] font-bold ${
                          filtersOpen ? "bg-white/25 text-white" : "bg-red-700 text-white"
                        }`}
                      >
                        {activeChips.length}
                      </span>
                    )}
                  </button>

                  <div className="text-[12.5px] text-gray-500">
                    <span className="font-bold text-gray-800">{filtered.length}</span>{" "}
                    of {pool.length} documents
                  </div>

                  {/* ---- right side: search + sort ---- */}
                  <div className="ml-auto flex items-center gap-2">
                    <HoverSearch
                      query={query}
                      setQuery={setQuery}
                      activeCat={activeCat}
                      onSubmit={scrollToGrid}
                    />

                    <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 hidden sm:inline">Sort</span>
                    <div className="relative">
                      <select
                        value={sort}
                        onChange={(e) => setSort(e.target.value)}
                        className="appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 outline-none text-[13px] font-semibold text-gray-700 pl-3 pr-9 py-2.5 cursor-pointer transition"
                      >
                        <option value="latest">Latest first</option>
                        <option value="oldest">Oldest first</option>
                        <option value="downloads">Most downloaded</option>
                        <option value="az">Title A–Z</option>
                      </select>
                      <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
                    </div>
                  </div>
                </div>

                {/* collapsible filters */}
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    filtersOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-4 md:px-5 pb-4 md:pb-5 border-t border-orange-200/30 pt-4 space-y-4">
                      <div className="flex flex-wrap gap-3">
                        <div className={selectCls}>
                          <Select label="Year" value={year} onChange={setYear} options={opts.years.map(String)} allLabel="All years" />
                        </div>
                        <div className={selectCls}>
                          <Select label="Topic" value={topic} onChange={setTopic} options={opts.topics} />
                        </div>
                        <div className={selectCls}>
                          <Select label="Region" value={region} onChange={setRegion} options={opts.regions} />
                        </div>
                      </div>

                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Format</span>
                        {["All", ...opts.types].map((t) => {
                          const active = typeF === t;
                          return (
                            <button
                              key={t}
                              onClick={() => setTypeF(t)}
                              className={`rounded-full px-3 py-1 text-[12px] font-semibold ring-1 transition-all duration-200 ${
                                active
                                  ? "bg-red-700 text-white ring-red-700 shadow-sm shadow-red-700/30 scale-[1.03]"
                                  : "bg-white text-gray-600 ring-orange-200/30 hover:ring-orange-400/60 hover:text-red-700"
                              }`}
                            >
                              {t === "All" ? "All formats" : t}
                            </button>
                          );
                        })}
                      </div>

                      {activeChips.length > 0 && (
                        <div className="flex items-center gap-2 flex-wrap pt-1">
                          <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Active</span>
                          {activeChips.map((c) => (
                            <button
                              key={c.k}
                              onClick={c.clear}
                              className="inline-flex items-center gap-1.5 rounded-full bg-orange-100 text-orange-800 ring-1 ring-orange-200/50 pl-3 pr-2 py-1 text-[12px] font-semibold hover:bg-orange-200/50 transition-colors"
                            >
                              {c.label}
                              <span className="w-4 h-4 rounded-full grid place-items-center bg-orange-200/50 hover:bg-orange-600 hover:text-white transition-colors">
                                <IconClose className="w-2.5 h-2.5" stroke={3} />
                              </span>
                            </button>
                          ))}
                          <button
                            onClick={clearAll}
                            className="text-[12px] font-semibold text-red-700 hover:underline underline-offset-2 ml-1"
                          >
                            Clear all
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>

            {/* ---- results header ---- */}
            <div className="mt-8 flex items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-red-700 to-orange-600 text-white grid place-items-center ring-1 ring-white/20">
                  <CatIcon className="w-[18px] h-[18px]" />
                </span>
                <div>
                  <div className="font-display text-[15px] font-bold text-gray-900">
                    {activeMeta.label}
                  </div>
                  <div className="text-[12px] text-gray-500">{activeMeta.short}</div>
                </div>
              </div>
            </div>

            {/* ---- grid ---- */}
            {docsLoading ? (
              <Reveal>
                <div className="mt-6 rounded-2xl bg-white ring-1 ring-orange-200/30 p-12 text-center">
                  <div className="mx-auto w-10 h-10 rounded-full border-2 border-orange-200 border-t-red-700 animate-spin" />
                  <p className="mt-4 text-sm text-gray-500">Loading documents…</p>
                </div>
              </Reveal>
            ) : docsError ? (
              <Reveal>
                <div className="mt-6 rounded-2xl bg-white ring-1 ring-red-200/50 p-12 text-center">
                  <p className="text-sm font-semibold text-red-700">Couldn't load documents.</p>
                  <p className="mt-1 text-sm text-gray-500">{docsError}</p>
                </div>
              </Reveal>
            ) : filtered.length === 0 ? (
              <Reveal>
                <div className="mt-6 rounded-2xl bg-white ring-1 ring-orange-200/30 p-12 text-center">
                  <div className="mx-auto w-16 h-16 rounded-2xl bg-[#FAF7F2] ring-1 ring-orange-200/30 grid place-items-center text-orange-700">
                    <IconSearch className="w-7 h-7" />
                  </div>
                  <h3 className="mt-5 font-display text-xl text-gray-900">No documents match your filters</h3>
                  <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
                    Try widening the year or region, clearing the format, or resetting your search.
                  </p>
                  <button
                    onClick={clearAll}
                    className="mt-6 inline-flex items-center gap-2 rounded-full bg-red-700 hover:bg-red-800 text-white text-sm font-semibold px-5 py-2.5 transition-colors"
                  >
                    <IconClose className="w-4 h-4" stroke={2.4} /> Clear all filters
                  </button>
                </div>
              </Reveal>
            ) : (
              <>
                <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {shown.map((doc, i) => (
                    <DocCard key={doc.id} doc={doc} index={i} />
                  ))}
                </div>

                {hasMore && (
                  <div className="mt-10 flex justify-center">
                    <button
                      onClick={() => setVisible((v) => v + 6)}
                      className="group inline-flex items-center gap-2.5 rounded-full bg-white ring-1 ring-orange-200/40 hover:ring-orange-500/70 text-gray-800 text-sm font-semibold px-7 py-3.5 shadow-sm hover:shadow-lg hover:shadow-orange-500/10 transition-all"
                    >
                      Load More Research Documents
                      <span className="w-6 h-6 rounded-full grid place-items-center bg-red-700/10 text-red-700 transition-all duration-300 group-hover:bg-red-700 group-hover:text-white group-hover:rotate-180">
                        <IconChevronDown className="w-3.5 h-3.5" stroke={2.6} />
                      </span>
                    </button>
                  </div>
                )}

                {!hasMore && filtered.length > 6 && (
                  <div className="mt-10 text-center text-[12.5px] text-gray-400">
                    You've reached the end of the {activeMeta.label.toLowerCase()} stream.
                  </div>
                )}
              </>
            )}
          </div>
        </section>
      </main>

      {/* --------- TIPS modal: sirf TIPS page pe mount hota hai --------- */}
      {isTipsPage && (
        <TipsInfoModal
          item={tipsItem}
          items={TIPS_NAV}
          onClose={closeTipsModal}
          onSelect={openTips}
        />
      )}
    </>
  );
}
